'use strict';
import angular from 'angular';
import $ from 'jquery';
import _ from 'lodash';
import CircularJSON from '../../../scripts/plugins/circular-json';
import addTaskHtmlUrl from '../../../views/shared/adminTasks.html';
import moment from "moment";

angular.module('workflows.ctrls', [])
    .controller('WorkflowController', WorkflowController)
    .controller('WorkflowActionController', WorkflowActionController)
    .controller('WorkflowTaskController', WorkflowTaskController)
    .controller('WorkflowViewController', WorkflowViewController)
    .controller('WfFullViewController', WfFullViewController)
    .controller('TaskPropertiesController', TaskPropertiesController)
    .controller('WfDecisionPropertiesController', WfDecisionPropertiesController)
    .controller('WfStatusChangerController', WfStatusChangerController)
    .controller('InitialStatusController', InitialStatusController)
    .controller('WorkflowGraphCtrl', WorkflowGraphCtrl);
WorkflowController.$inject = ['$scope', '$rootScope', 'WorkflowsService', '$modal', '$state', '$ioAlert', 'ClusterService', 'DateRangeService', 'ProductService', 'UserService', '$rootScope', '$confirm', 'ModalService', 'StepGroupService', 'StepsService', 'anchorSmoothScroll', '$location', '$timeout', 'FormService'];

function WorkflowController($scope, $rootScope, WorkflowsService, $modal, $state, $ioAlert, ClusterService, DateRangeService, ProductService, UserService, $rs, $confirm, ModalService, StepGroupService, StepsService, anchorSmoothScroll, $location, $timeout, FormService) {
    const WORKFLOW_TYPE_ORDER = 1;
    const WORKFLOW_TYPE_LINEITEM = 2;
    const WORKFLOW_TYPE_CLIENT = 3;
    const WORKFLOW_TYPE_FLIGHT = 4;

    $scope.workflows = [];
    $scope.workflowTypes = [];
    $scope.workflowActions = [];
    $scope.lineItemStatusList = [];
    $scope.orderStatusList = [];
    $scope.clientStatusList = [];
    $scope.flightStatusList = [];
    $scope.clusters = [];
    $scope.products = [];
    $scope.stepGroups = [];
    $scope.showActiveWorkflow = true;
    $scope.disableBtnAction = false;

    var clusterSelector = $rs.$on('ClusterChanged', function(event, args) {
        getProducts();
    });

    $scope.$on('$destroy', function() {
        clusterSelector();
    });

    var getProducts = function() {
        $rootScope.loadingInProgress = true;
        $rootScope.loadertitle = "Fetching Workflows";
        if (ClusterService.clusterIds[0] == 0) {
            ProductService.getAllProducts().then(function (success) {
                $scope.products = ProductService.products;
                getOrderStatuses();
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                $rootScope.loadingInProgress = false;
            });
        } else {
            // Set showAll to true so that we don't have to fetch products again if the user changes the active setting.
            // We'll filter out inactive products for use by the modal window that adds or updates workflows, for selection.
            ProductService.getProducts(ClusterService.clusterIds[0], true).then(function (success) {
                $scope.products = ProductService.products;
                getOrderStatuses();
            }, function (error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                $rootScope.loadingInProgress = false;
            });
        }
    };

    var getOrderStatuses = function() {
        $scope.orderStatusReq = WorkflowsService.getOrderStatuses().then(function(success) {
            $scope.orderStatusList = WorkflowsService.orderStatusList;
            getClientStatuses();
        }, function(error) {
            console.log("error loading order statuses");
            $rootScope.loadingInProgress = false;
        });
    };

    var getClientStatuses = function() {
        $scope.clientStatusReq = WorkflowsService.getClientStatuses().then(function(success) {
            $scope.clientStatusList = WorkflowsService.clientStatusList;
            getLineItemStatuses();
        }, function(error) {
            console.log("error loading client statuses");
            $rootScope.loadingInProgress = false;
        });
    };

    var getLineItemStatuses = function() {
        $scope.lineItemStatusReq = WorkflowsService.getLineItemStatuses().then(function(success) {
            $scope.lineItemStatusList = WorkflowsService.lineItemStatusList;
            getflightStatuses();
        }, function(error) {
            console.log("error loading line item statuses");
            $rootScope.loadingInProgress = false;
        });
    };

    var getflightStatuses = function() {
        $scope.flightStatusReq = WorkflowsService.getFlightStatuses().then(function(success) {
            $scope.flightStatusList = WorkflowsService.flightStatusList;
            getGroups();
        }, function(error) {
            console.log("error loading flight statuses");
            $rootScope.loadingInProgress = false;
        });
    };

    var getGroups = function() {
        var showAll = {showAll:0};
        StepGroupService.getStepGroups(showAll).then(function(response) {
            $scope.stepGroups = response[0].workflowStepGroups;
            getWorkflowList();
        }, function(error) {
            console.log("Error getting steps");
            $rootScope.loadingInProgress = false;
        });
    };

    var getWorkflowList = function() {
        WorkflowsService.getWorkflowsList(ClusterService.clusterIds[0], !$scope.showActiveWorkflow).then(function(success) {
            $scope.workflows = WorkflowsService.workflowsList;
            $rootScope.loadingInProgress = false;
            workflowHelper();
        }, function(error) {
            console.log("error loading workflow list");
            $rootScope.loadingInProgress = false;
        });
    };

    var workflowHelper = function() {
        for (let i = 0, len = $scope.workflows.length; i < len; i++) {
            if ($scope.workflows[i].type_id == WORKFLOW_TYPE_ORDER || $scope.workflows[i].type_id == WORKFLOW_TYPE_CLIENT) {
                if ($scope.workflows[i].type_id == WORKFLOW_TYPE_ORDER) {
                    for (let j = 0, size = $scope.orderStatusList.length; j < size; j++) {
                        if ($scope.workflows[i].initial_status_id == $scope.orderStatusList[j].id) {
                            $scope.workflows[i].statusName = $scope.orderStatusList[j].name;
                        }
                    }
                } else if ($scope.workflows[i].type_id == WORKFLOW_TYPE_CLIENT) {
                    for (let j = 0, size = $scope.clientStatusList.length; j < size; j++) {
                        if ($scope.workflows[i].initial_status_id == $scope.clientStatusList[j].id) {
                            $scope.workflows[i].statusName = $scope.clientStatusList[j].name;
                        }
                    }
                }
                // We want a boolean
                $scope.workflows[i].isDefault = $scope.workflows[i].is_default == "1";

                let numClusters = $scope.workflows[i].cluster_ids.length;
                if (numClusters === 0) {
                    $scope.workflows[i].refName = ''; // Not expected
                }
                else if (numClusters === 1) {
                    for (let k = 0, clusterCount = $scope.clusters.length; k < clusterCount; k++) {
                        if ($scope.workflows[i].cluster_ids.includes($scope.clusters[k].id)) {
                            $scope.workflows[i].refName = $scope.clusters[k].name;
                        }
                    }
                }
                else if (numClusters === 2) {
                    let numFound = 0;
                    for (let k = 0, clusterCount = $scope.clusters.length; k < clusterCount; k++) {
                        if ($scope.workflows[i].cluster_ids.includes($scope.clusters[k].id)) {
                            if (numFound === 0) {
                                $scope.workflows[i].refName = $scope.clusters[k].name;
                                numFound++;
                            }
                            else if (numFound >= 1) {
                                $scope.workflows[i].refName = $scope.workflows[i].refName + ', ' + $scope.clusters[k].name;
                                numFound++;
                            }
                        }
                    }
                }
                else {
                    // Output the name of the cluster matching the selected cluster (top-right corner), and the
                    // number of other ones.  We can't display them all as the page would be cluttered.  If the current
                    // BU selection is not among the workflow cluster list, then just display the count, in parentheses.
                    for (let k = 0, clusterCount = $scope.clusters.length; k < clusterCount; k++) {
                        if (ClusterService.clusterIds[0] == $scope.clusters[k].id) {
                            if ($scope.workflows[i].cluster_ids.includes($scope.clusters[k].id)) {
                                // The selected cluster for the page is in the cluster list for the workflow, so display
                                // that cluster's name, and the count of other clusters assigned to this workflow.
                                $scope.workflows[i].refName = $scope.clusters[k].name + ' and ' + (numClusters - 1) + ' others';
                            }
                            else {
                                // The selected cluster for the page is not in the cluster list for this workflow, so
                                // just display the count.
                                $scope.workflows[i].refName = '(' + numClusters + ' business units)';
                            }
                            break;
                        }
                    }
                }
            } else if ($scope.workflows[i].type_id == WORKFLOW_TYPE_LINEITEM) {
                for (let j = 0, size = $scope.lineItemStatusList.length; j < size; j++) {
                    if ($scope.workflows[i].initial_status_id == $scope.lineItemStatusList[j].id) {
                        $scope.workflows[i].statusName = $scope.lineItemStatusList[j].name;
                    }
                }
                for (let k = 0, lineItemRefSize = $scope.products.length; k < lineItemRefSize; k++) {
                    if ($scope.workflows[i].product_id == $scope.products[k].id) {
                        $scope.workflows[i].refName = $scope.products[k].name;
                    }
                }
            } else if ($scope.workflows[i].type_id == WORKFLOW_TYPE_FLIGHT) {
                for (let j = 0, size = $scope.flightStatusList.length; j < size; j++) {
                    if ($scope.workflows[i].initial_status_id == $scope.flightStatusList[j].id) {
                        $scope.workflows[i].statusName = $scope.flightStatusList[j].name;
                    }
                }
                for (let k = 0, flightRefSize = $scope.products.length; k < flightRefSize; k++) {
                    if ($scope.workflows[i].product_id == $scope.products[k].id) {
                        $scope.workflows[i].refName = $scope.products[k].name;
                    }
                }
            }
            $scope.workflows[i].active = $scope.workflows[i].active == "1";
            for (let k = 0; k < $scope.stepGroups.length; k++) {
                if ($scope.workflows[i].workflow_step_group_id == $scope.stepGroups[k].id) {
                    $scope.workflows[i].stepGroup = $scope.stepGroups[k];
                }
            }

            if ($scope.workflows[i].created_at != null) {
                $scope.workflows[i].created_at = moment($scope.workflows[i].created_at).local().format('YYYY-MM-DD');
            }

            if ($scope.workflows[i].active_updated_at != null) {
                $scope.workflows[i].active_updated_at = moment($scope.workflows[i].active_updated_at).local().format('YYYY-MM-DD');
            }
        }
    };

    $scope.addNew = function(workflow) {
        $scope.isNew = (workflow == null);

        var modalObj = $modal.open(
            ModalService.returnModalType('createWorkflow', {
                data: {
                    workflow: workflow,
                    workflowTypes: $scope.workflowTypes,
                    orderStatusList: $scope.orderStatusList,
                    clientStatusList: $scope.clientStatusList,
                    lineItemStatusList: $scope.lineItemStatusList,
                    flightStatusList: $scope.flightStatusList,
                    clusters: ClusterService.clusters.slice(1),  // Shallow copy, skipping item 0 (All Business Units)
                    lineItemRefList: $scope.products.filter(product => product['active'] == 1), // Filter out inactive products for selection
                    flightRefList: $scope.products.filter(product => product['active'] == 1),
                    stepGroups: $scope.stepGroups,
                    StepGroupService: StepGroupService
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if ($scope.isNew) {
                WorkflowsService.addWorkflow(formObj).then(function(data) {
                    if (data.errors) {
                        $ioAlert.show('', data.errors, 'error');
                    } else {
                        getWorkflowList();
                        $ioAlert.show('', 'Workflow created successfully', 'success');
                        $location.hash('bottom-scroll');
                        anchorSmoothScroll.scrollTo('bottom-scroll');
                        $timeout(function() {
                            $location.hash('');
                        }, 1000);
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                WorkflowsService.updateWorkflow(formObj).then(function(data) {
                    if (data.errors) {
                        $ioAlert.show('', data.errors, 'error');
                    } else {
                        if (data.workflow) {
                            $ioAlert.show('', 'Workflow updated successfully', 'success');
                            getWorkflowList();
                        }
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        })
    };

    // The delete button was replaced with an active field, configured in the modal add/update workflow modal window.
    //
    // $scope.deleteWf = function(workflowId) {
    //     if (workflowId) {
    //         $confirm.open({
    //             size: 'sm',
    //             text: 'Are you sure you want to delete this workflow?'
    //         }).then(function() {
    //             WorkflowsService.toggleWorkflowState(workflowId).then(function(data) {
    //                 for (var i = 0, len = $scope.workflows.length; i < len; i++) {
    //                     if ($scope.workflows[i].id == workflowId) {
    //                         $scope.workflows.splice(i, 1);
    //                         break;
    //                     }
    //                 }
    //                 $ioAlert.show('', 'Workflow deleted successfully', 'success');
    //             }, function(error) {
    //                 $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
    //             })
    //         }, function() {})
    //     }
    // };

    // Helper function to export a workflow
    $scope.exportWorkflow = function(workflow) {
        WorkflowsService.exportWorkflow(workflow.id).then(function(response) {
            let errors = response.data.errors;
            if (errors) {
                $ioAlert.show('', 'An error occurred exporting workflow: ' + errors[0], 'error');
                console.log(errors);
            } else {
                let csvString = response.data;
                let a = $('<a/>', {
                    style: 'display:none',
                    href: 'data:application/octet-stream;base64,' + btoa(unescape(encodeURIComponent(csvString))),
                    download: 'workflow_' + workflow.id + '.csv'
                }).appendTo('body');
                a[0].click();
                a.remove();
                $ioAlert.show('', 'File exported successfully', 'success');
            }
        }, function(error) {
            $ioAlert.show('', 'An error occurred exporting workflow.', 'error');
            console.log(error);
        });
    };

    // Helper function to import a workflow
    $scope.importWorkflow = function() {
        if ($scope.uploadMedia.file && $scope.uploadMedia.file.length) {
            $ioAlert.show('', 'File is being uploaded, please do not refresh the page', 'success');
            WorkflowsService.importWorkflow($scope.uploadMedia.file).then(function(response) {
                if (response.errors) {
                    for (var i = 0, len = response.errors.length; i < len; i++) {
                        $ioAlert.show('ERROR!', response.errors[i], 'error');
                    }
                    console.log(response.errors);
                } else {
                    $ioAlert.show('', 'File Imported successfully', 'success');
                    $rootScope.loadingInProgress = true;
                    getWorkflowList();                    }
            }, function(error) {
                console.log("Error importing workflow: " + error);
            });
        }
    };

    $scope.filterWorkflowActive = function() {
        $scope.showActiveWorkflow = !$scope.showActiveWorkflow;
        $rootScope.loadingInProgress = true;
        getWorkflowList();
    };

    $scope.viewTask = function(workflow) {
        $state.go('workflowTask', {
            "id": workflow.id
        })
    };

    $scope.view = function(workflow) {
        $state.go('workflowView', {
            "id": workflow.id,
            "workflow": workflow
        });
    };

    $scope.viewRuleSet = function(workflow) {
        $state.go('routingRuleSet', {
            "id": workflow.id
        })
    };

    $scope.viewWorkflowActions = function() {
        $state.go('workflowActions');
    };

    $scope.createWFTemplate = function() {
        $modal.open(
            ModalService.returnModalType('createWfTemplate', {
                data: {
                    workflowTypes: $scope.wfTemplateTypes
                }
            })
        ).result.then(function() {

        });
    }

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    var init = function() {
        ClusterService.initCluster($rs.userRole).then(function() {
            $scope.clusters = ClusterService.clusters;

            WorkflowsService.getWorkflowTypes().then(function(success) {
                $scope.workflowTypes = WorkflowsService.workflowTypes;
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });

            WorkflowsService.getTemplateWorkflowTypes().then(function(response) {
                if (response.template_types) {
                    $scope.wfTemplateTypes = response.template_types;
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
        DateRangeService.init();
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };
    UserService.adjustStickyHeaderWindowResize();

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

WorkflowActionController.$inject = ['$scope', 'WorkflowsService', '$modal', '$state', '$ioAlert', 'ClusterService', 'UserService', '$rootScope', '$confirm', 'ModalService', 'FormService'];

function WorkflowActionController($scope, WorkflowsService, $modal, $state, $ioAlert, ClusterService, UserService, $rs, $confirm, ModalService, FormService) {
    $scope.workflowActions = [];
    $scope.disableBtnAction = false;

    var getWorkflowActions = function() {
        WorkflowsService.getWorkflowActions().then(function(success) {
            $scope.workflowActions = WorkflowsService.workflowActions;
        }, function(error) {
            console.log("error loading workflow actions list");
        });
    };

    $scope.addOrEditWorkflowAction = function(workflowAction) {
        $scope.isNew = (workflowAction == null);

        var modalObj = $modal.open(
            ModalService.returnModalType('createWorkflowAction', {
                data: {
                    workflowAction: workflowAction
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if (formObj.active) {
                formObj.active = 1;
            } else {
                formObj.active = 0;
            }
            if (formObj.custom_edit) {
                formObj.custom_edit = 1;
            } else {
                formObj.custom_edit = 0;
            }

            if ($scope.isNew) {
                WorkflowsService.addWorkflowAction(formObj).then(function(success) {
                    $scope.workflowActions.push(WorkflowsService.workflowAction);
                }, function(error) {
                    console.log("error saving workflow action");
                });
            } else {
                formObj.id = workflowAction.id;
                delete formObj.mutable;

                WorkflowsService.updateWorkflowAction(formObj).then(function(success) {
                    for (var x = 0; x < $scope.workflowActions.length; x++) {
                        if ($scope.workflowActions[x].id == WorkflowsService.workflowAction.id) {
                            $scope.workflowActions[x] = WorkflowsService.workflowAction;
                            break;
                        }
                    }
                }, function(error) {
                    console.log("error updating workflow action");
                });
            }
        }, function() {})
    };

    $scope.viewWorkflows = function(workflow) {
        $state.go('workflows');
    };

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();
    var init = function() {
        ClusterService.initCluster($rs.userRole).then(function() {
            $scope.clusters = ClusterService.clusters;

            WorkflowsService.getWorkflowActions().then(function(success) {
                $scope.workflowActions = WorkflowsService.workflowActions;
            }, function(error) {
                console.log("error loading workflow actions");
            });
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
        getInstanceLockConfig();
        UserService.adjustStickyHeader();
    };

    if ($rs.userRole && $rs.userRole.id) {
        init();
    } else {
        UserService.getCurrentUserRole().then(function() {
            $rs.userRole = UserService.userRole;
            init();
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
}

WorkflowTaskController.$inject = ['$scope', '$stateParams', '$state', 'WorkflowsService', '$modal', '$ioAlert', 'TaskService', 'ModalService'];

function WorkflowTaskController($scope, $stateParams, $state, WorkflowsService, $modal, $ioAlert, TaskService, ModalService) {
    $scope.workflowId = $stateParams.id;
    $scope.workflowTasks = [];
    $scope.workflowActions = [];

    var getWorkflowTaskList = function() {
        WorkflowsService.getWorkflowTasksList($scope.workflowId).then(function(success) {
            $scope.workflowTasks = WorkflowsService.workflowTaskList;
            if (!$scope.workflowTasks) {
                $scope.workflowTasks = [];
            }
        }, function(error) {
            console.log("error loading tasks list");
        });
    };

    var getWorkflowActions = function() {
        WorkflowsService.getWorkflowActions().then(function(success) {
            $scope.workflowActions = WorkflowsService.workflowActions;
        }, function(error) {
            console.log("error loading workflow action list");
        });
    };

    var getTasksList = function() {
        TaskService.getTasksList().then(function(success) {
            $scope.tasksList = TaskService.tasksList;
        });
    };

    $scope.addNew = function(task) {
        $scope.isNew = (task == null);

        var modalObj = $modal.open(
            ModalService.returnModalType('addWorkflowTask', {
                data: {
                    workflowId: $scope.workflowId,
                    task: task,
                    workflowActions: $scope.workflowActions,
                    tasksList: $scope.tasksList
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if ($scope.isNew) {
                WorkflowsService.addWorkflowTask(formObj).then(function(data) {
                    $scope.workflowTasks.push(data);
                    $ioAlert.show('', 'Workflow Task created successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            } else {
                WorkflowsService.updateWorkflowTask(formObj).then(function(data) {
                    if (data) {
                        for (var i = 0, len = $scope.workflowTasks.length; i < len; i++) {
                            if ($scope.workflowTasks[i].id == data.id) {
                                $scope.workflowTasks[i] = data;
                            }
                        }
                        $ioAlert.show('', 'Workflow task updated successfully', 'success');
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }
        }, function(cancel) {
            console.log("cancel");
        });
    };

    $scope.backToList = function() {
        $state.go('workflowView', {
            'id': $scope.workflowId
        });
    };

    var init = function() {
        getWorkflowTaskList();
        getWorkflowActions();
        getTasksList();
    };
    init();
}

WorkflowViewController.$inject = ['$rootScope', '$scope', '$stateParams', '$timeout','WorkflowsService', 'StepGroupService', '$modal', '$ioAlert', '$state', 'TapIoRuleSetService', 'TaskService', '$confirm', 'ModalService', 'ClusterService', 'UserService', 'FormService'];

function WorkflowViewController($rs, $scope, $stateParams, $timeout, WorkflowsService, StepGroupService, $modal, $ioAlert, $state, TapIoRuleSetService, TaskService, $confirm, ModalService, ClusterService, UserService, FormService) {
    $scope.workflowId = $stateParams.id;

    $scope.ruleSets = [];
    //Routing Rules List
    $scope.rulesListObj = {};
    $scope.routingConditionsObj = {};
    $scope.workflowTasks = [];
    $scope.workflowTaskInterlockings = [];
    $scope.workflowActions = [];
    $scope.workflowObj = $stateParams.workflow;
    $scope.workflowInfoObj = {};
    $scope.statusList = [];
    $scope.tapIORuleSets = [];
    $scope.scheduledRouting = false;
    $scope.workflowSortBy = "";
    $scope.workflowSearch = {
        "byVal": "Action",
        "keyVal": ""
    };
    $scope.hideSearch = true;
    $scope.showWorkflowActions = false;
    $scope.willExpandAllGroups = true;
    $scope.isExpandCollapseButtonDisabled = true;

    // for phase1 we are giving authorization for specific users
    var authorizedUsers = [
        'myk.crouch@tapclicks.com',
        'christina.reidy@tapclicks.com',
        'kristin.lundin@tapclicks.com',
        'owen.davis@tapclicks.com',
        'zhala@tapclicks.com',
        'erica.lundin@tapclicks.com',
        'megan@tapclicks.com',
        'robert.winters@tapclicks.com'
    ];
    $scope.showGraphicalWorkflow = false;
    $scope.disableBtnAction = false;

    $scope.$watch('scheduledRouting', function(nV, oV) {
        if (nV !== oV) {
            getRoutingRuleSetsList();
        }
    });
    $scope.$watch('workflowSortBy', function(nV, oV) {
        if (nV !== oV) {
            if (nV == "Action") {
                $scope.ruleSets = _.sortBy($scope.ruleSets, ['workflowActionName']);
            } else if (nV == "Status") {
                $scope.ruleSets = _.sortBy($scope.ruleSets, ['statusName']);
            }
        }
    });

    $scope.steps = [];

    var getWorkflowInfo = function() {
        $rs.loadingInProgress = true;
        $rs.loadertitle = "Fetching workflow ruleSets";
        WorkflowsService.getWorkflowInfo($scope.workflowId).then(function(success) {
            $scope.workflowInfoObj = WorkflowsService.workflowInfo;
            if ($scope.workflowInfoObj.workflow_type_name == 'Order') {
                getOrderStatuses();
            } else if ($scope.workflowInfoObj.workflow_type_name == 'Client') {
                getClientStatuses();
            } else if ($scope.workflowInfoObj.workflow_type_name == 'LineItem') {
                getLineItemStatuses();
            } else {
                getFlightStatuses();
            }
            if ($scope.workflowInfoObj.workflow_step_group_id) {
                getSteps();
            }
        }, function(error) {
            console.log("error getting workflow info for workflow id: " + $scope.workflowId);
        });
    };

    // /*
    //  * Helper function to update the workflow graph whenever something is changed on the card view
    //  * We will clear the ioGraph and the rendering will happen from a normal view
    //  */
    // function updateWorkflowGraph() {
    //     var workflowParam = {
    //         id: $scope.workflowInfoObj.id,
    //         hasIoGraph: "0",
    //         ioGraph: "",
    //         initialStatusId: $scope.workflowInfoObj.initial_status_id,
    //         name: $scope.workflowInfoObj.name,
    //         typeId: $scope.workflowInfoObj.type_id,
    //         referenceId: $scope.workflowInfoObj.reference_id,
    //         workflowStepGroupId: $scope.workflowInfoObj.workflow_step_group_id,
    //         initialStepId: $scope.workflowInfoObj.initial_step_id
    //     }
    //     WorkflowsService.updateWorkflow(workflowParam).then(function(response) {
    //
    //     }, function(error) {});
    // }

    var getSteps = function() {
        StepGroupService.getStepsXrefs({
            'workflowStepGroupId': $scope.workflowInfoObj.workflow_step_group_id
        }).then(function(response) {
            $scope.steps = response.workflowStepGroupXrefs;
        }, function(error) {})
    };

    // If the type of workflow is order, get Order Status List
    var getOrderStatuses = function() {
        WorkflowsService.getOrderStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.orderStatusList;
            getRoutingRuleSetsList();
        }, function(error) {
            console.log("error loading order statuses");
        });
    };

    // If the type of workflow is client, get Client Status List
    var getClientStatuses = function() {
        WorkflowsService.getClientStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.clientStatusList;
            getRoutingRuleSetsList();
        }, function(error) {
            console.log("error loading client statuses");
        });
    };

    // If the type of workflow is lineItem, get Line Item Status List
    var getLineItemStatuses = function() {
        WorkflowsService.getLineItemStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.lineItemStatusList;
            getRoutingRuleSetsList();
        }, function(error) {
            console.log("error loading lineitem statuses");
        });
    };

    // If the type of workflow is flight, get flight status list
    var getFlightStatuses = function() {
        WorkflowsService.getFlightStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.flightStatusList;
            getRoutingRuleSetsList();
        }, function(error) {
            console.log("error loading flight statuses");
        });
    };

    //Get Routing Rule Set list for a Workflow based on workflow id
    var getRoutingRuleSetsList = function() {
        var initial_status = _.find($scope.statusList, { id: $scope.workflowInfoObj.initial_status_id });
        if (initial_status) {
            $scope.workflowInfoObj.initial_status_name = initial_status.name;
        }
        WorkflowsService.getRoutingRuleSets($scope.workflowId, $scope.scheduledRouting).then(function(success) {
            $scope.ruleSets = WorkflowsService.routingRuleSets;
            getWorkflowActions();
            getWorkflowTaskList();
            getWorkflowTaskInterlockingsList();
            updateRoutingRuleSetStatus();
            $scope.isExpandCollapseButtonDisabled = WorkflowsService.routingRuleSets.length === 0;
            $rs.loadingInProgress = false;
            getRoutingRulesAndConditions();
            $scope.showWorkflowActions = true;
        }, function(error) {
            console.log("error loading routing rule sets list");
            $rs.loadingInProgress = false;
        })
    };

    var getWorkflowTaskList = function() {
        WorkflowsService.getWorkflowTasksList($scope.workflowId).then(function(success) {
            $scope.workflowTasks = WorkflowsService.workflowTaskList;
            if (!$scope.workflowTasks) {
                $scope.workflowTasks = [];
            }
        }, function(error) {
            console.log("error loading tasks list");
        });
    };

    var getWorkflowTaskInterlockingsList = function() {
        WorkflowsService.getWorkflowTaskInterlockingsList($scope.workflowId).then(function(success) {
            $scope.workflowTaskInterlockings = WorkflowsService.workflowTaskInterlockingList;
            if (!$scope.workflowTaskInterlockings) {
                $scope.workflowTaskInterlockings = [];
            }
        }, function(error) {
            console.log("error loading tasks list");
        });
    };

    var getWorkflowActions = function() {
        WorkflowsService.getActiveWorkflowActions().then(function(success) {
            $scope.workflowActions = WorkflowsService.workflowActions;
            workflowActionsHelpr();
        }, function(error) {
            console.log("error loading workflow actions list");
        });
    };

    var getTapIORuleSets = function() {
        TapIoRuleSetService.getRuleSets().then(function(success) {
            $scope.tapIORuleSets = TapIoRuleSetService.ruleSets;
        }, function(error) {
            console.log("error loading ruleSets list");
        });
    };

    //Helper function to map task name to a id
    var workflowTaksHelper = function(ruleSetId) {
        for (var k = 0, size = $scope.rulesListObj[ruleSetId].length; k < size; k++) {
            $scope.rulesListObj[ruleSetId][k].task = [];
            $scope.rulesListObj[ruleSetId][k].interlocking = [];
        }
        for (var i = 0, len = $scope.workflowTasks.length; i < len; i++) {
            for (var j = 0, size = $scope.rulesListObj[ruleSetId].length; j < size; j++) {
                if ($scope.rulesListObj[ruleSetId][j].id == $scope.workflowTasks[i].routing_rule_id) {
                    $scope.rulesListObj[ruleSetId][j].task.push({
                        "taskId": $scope.workflowTasks[i].id,
                        "taskName": $scope.workflowTasks[i].name
                    });
                }
            }
        }
        for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
            for (var j = 0, size = $scope.rulesListObj[ruleSetId].length; j < size; j++) {
                if ($scope.rulesListObj[ruleSetId][j].id == $scope.workflowTaskInterlockings[i].routing_rule_id) {
                    $scope.rulesListObj[ruleSetId][j].interlocking.push({
                        "interlockingId": $scope.workflowTaskInterlockings[i].id,
                        "interlockingName": $scope.workflowTaskInterlockings[i].name
                    });
                }
            }
        }
    };

    //Helper function to map WOrkflow Action name to a id
    var workflowActionsHelpr = function() {
        for (var i = 0, len = $scope.workflowActions.length; i < len; i++) {
            for (var j = 0, size = $scope.ruleSets.length; j < size; j++) {
                if ($scope.ruleSets[j].workflow_action_id == $scope.workflowActions[i].id) {
                    $scope.ruleSets[j].workflowActionName = $scope.workflowActions[i].name;
                }
            }
        }
    };

    //Helper function to map Workflow step name to a id
    var workflowStepsHelper = function(ruleSetId) {
        for (var i = 0, len = $scope.steps.length; i < len; i++) {
            for (var k = 0, size = $scope.rulesListObj[ruleSetId].length; k < size; k++) {
                if ($scope.rulesListObj[ruleSetId][k].workflow_step_id && $scope.steps[i].workflow_step_id == $scope.rulesListObj[ruleSetId][k].workflow_step_id) {
                    $scope.rulesListObj[ruleSetId][k].step = $scope.steps[i];
                }
            }
        }
    };

    //Helper function to map rule set status name to id
    var updateRoutingRuleSetStatus = function() {
        for (let i = 0, len = $scope.ruleSets.length; i < len; i++) {
            let first = true;
            let statusNames = '';
            const statusIds = $scope.ruleSets[i].status_ids;
            if (statusIds) {
                for (let j = 0, size = statusIds.length; j < size; j++) {
                    const statusId = statusIds[j];
                    const statusListItem = $scope.statusList.find(element => element.id == statusId);
                    if (statusListItem) {
                        if (first) {
                            first = false;
                        } else {
                            statusNames += ', ';
                        }
                        statusNames += statusListItem.name;
                    }
                }
            }
            $scope.ruleSets[i].statusName = statusNames;
        }
    };

    var updateRoutingRuleStatus = function(ruleId) {
        for (let i = 0, len = $scope.rulesListObj[ruleId].length; i < len; i++) {
            for (let j = 0, size = $scope.statusList.length; j < size; j++) {
                if ($scope.statusList[j].id == $scope.rulesListObj[ruleId][i].status_id) {
                    $scope.rulesListObj[ruleId][i].statusName = $scope.statusList[j].name;
                }
            }
        }
    };

    var updateRoutingRuleAuxiliaryActionNames = function(ruleId) {
        for (let i = 0, len = $scope.rulesListObj[ruleId].length; i < len; i++) {
            for (let j = 0, size = $scope.workflowActions.length; j < size; j++) {
                if ($scope.workflowActions[j].id == $scope.rulesListObj[ruleId][i].auxiliary_action_up) {
                    $scope.rulesListObj[ruleId][i].auxiliaryActionUpName = $scope.workflowActions[j].name;
                }
                if ($scope.workflowActions[j].id == $scope.rulesListObj[ruleId][i].auxiliary_action_down) {
                    $scope.rulesListObj[ruleId][i].auxiliaryActionDownName = $scope.workflowActions[j].name;
                }
            }
        }
    };

    var getTasksList = function() {
        TaskService.getTasksList().then(function(success) {
            $scope.tasksList = TaskService.tasksList;
        });
    };

    $scope.toggleInformationBeingDisplayed = function() {
        $scope.isExpandCollapseButtonDisabled = true;
        let isExpandingAllGroups = $scope.willExpandAllGroups;
        $scope.willExpandAllGroups = !$scope.willExpandAllGroups;
        $timeout(function () {
            if (isExpandingAllGroups) {
                $('span[data-toggle-display="expand"]').click();
            } else {
                $('span[data-toggle-display="collapse"]').click();
            }
        }, 0);
        $timeout(function () {
            $scope.isExpandCollapseButtonDisabled = false;
        }, 200);
    }

    // Toggle function which shows the routing rule and routing condition for a routing rule set
    $scope.toggle = function(ev, rule) {
        $(ev.target).siblings(':last').slideToggle(200);
        if ($(ev.target).attr('class').indexOf('fa-chevron-right') > 0) {
            $(ev.target).removeClass('fa-chevron-right');
            $(ev.target).addClass('fa-chevron-down');
            $(ev.target).attr('data-toggle-display', 'collapse');
            afterExpandingGroup();
            $scope.rulesListObj[rule.id] = [];
            $scope.routingConditionsObj[rule.id] = [];
            WorkflowsService.getRoutingRules(rule.id).then(function(success) {
                $scope.rulesListObj[rule.id] = WorkflowsService.routingRulesList;
                workflowStepsHelper(rule.id);
                workflowTaksHelper(rule.id);
                updateRoutingRuleStatus(rule.id);
                updateRoutingRuleAuxiliaryActionNames(rule.id);
            }, function(error) {
                console.log("error loading routing rules list");
            });
            WorkflowsService.getRoutingConditions(rule.id).then(function(success) {

                $scope.routingConditionsObj[rule.id] = WorkflowsService.routingConditions;
                _.map($scope.routingConditionsObj[rule.id], function(routingCondition) {
                    var obj = _.find($scope.tapIORuleSets, function(ruleSet) {
                        return ruleSet.id == routingCondition.rule_set_id
                    });
                    routingCondition.rule_set_name = obj.name;
                    return routingCondition;
                });

            }, function(error) {
                console.log("error loading routing conditions list");
            });
        } else {
            $(ev.target).removeClass('fa-chevron-down');
            $(ev.target).addClass('fa-chevron-right');
            $(ev.target).attr('data-toggle-display', 'expand');
            afterCollapsingGroup();
        }
    };

    function afterExpandingGroup() {
        let count = $('span[data-toggle-display="expand"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = false;
        }
    }

    function afterCollapsingGroup() {
        let count = $('span[data-toggle-display="collapse"]').length;
        if (count === 0) {
            $scope.willExpandAllGroups = true;
        }
    }

    //Add Edit Rule Set
    $scope.addEditRuleSet = function(ruleSet) {
        var isNew = (ruleSet) ? false : true;
        var modalObj = $modal.open(
            ModalService.returnModalType('addRoutingRuleSet', {
                data: {
                    isNew: isNew,
                    ruleSet: ruleSet,
                    workflowActions: $scope.workflowActions,
                    workflowId: $scope.workflowId,
                    statusList: $scope.statusList,
                    scheduledRouting: $scope.scheduledRouting,

                }
            })
        );

        modalObj.result.then(function (formObj) {
            if (formObj) {
                formObj.isDefault = formObj.isDefault ? 1 : 0;
                if (isNew) {
                    WorkflowsService.addRoutingRuleSet(formObj, $scope.scheduledRouting).then(function (data) {
                        if (data) {
                            $scope.ruleSets.push(data);
                            workflowActionsHelpr();
                            updateRoutingRuleSetStatus();
                            $ioAlert.show('', 'Routing Rule Set added successfully', 'success');
                        }
                    }, function (error) {
                        console.log("Error saving routing rule set: " + error);
                        $ioAlert.show('Error!', error, 'error');
                    })
                } else {
                    WorkflowsService.updateRoutingRuleSet(formObj, $scope.scheduledRouting).then(function (data) {
                        if (data.is_default) {
                            for (var i = 0, len = $scope.ruleSets.length; i < len; i++) {
                                $scope.ruleSets[i].is_default = 0;
                            }
                        }
                        for (var i = 0, len = $scope.ruleSets.length; i < len; i++) {
                            if (data.id == $scope.ruleSets[i].id) {
                                $scope.ruleSets[i] = data;
                                workflowActionsHelpr();
                                updateRoutingRuleSetStatus();
                                $ioAlert.show('', 'Routing Rule Set updated successfully', 'success');
                            }
                        }
                    }, function (error) {
                        console.log("Error updating routing rule set: " + error);
                        $ioAlert.show('Error!', error, 'error');
                    })
                }
                //updateWorkflowGraph();
            } else {
                $scope.deleteRuleSet(ruleSet.id);
            }
        }, function (cancel) {
            console.log("cancel");
        })
    };

    $scope.backToList = function() {
        $state.go('workflows');
    };

    // add/Edit Routing Rule
    $scope.addRule = function(ruleSetId, routingRule) {
        var isNew = (routingRule) ? false : true;

        var modalObj = $modal.open(
            ModalService.returnModalType('createRoutingRule', {
                data: {
                    ruleSetId: ruleSetId,
                    routingRule: routingRule,
                    statusList: $scope.statusList,
                    workflowActions: $scope.workflowActions,
                    workflowTypeName: $scope.workflowInfoObj.workflow_type_name,
                    scheduledRouting: $scope.scheduledRouting,
                    steps: $scope.steps,
                    worflowStepId: $scope.workflowStepId
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if(formObj){
                formObj.defaultRule = formObj.defaultRule ? 'yes' : 'no';

                if (isNew) {
                    WorkflowsService.addRoutingRules(formObj, $scope.scheduledRouting).then(function(data) {
                        if (data) {
                            if (!$scope.rulesListObj[ruleSetId]) {
                                $scope.rulesListObj[ruleSetId] = [];
                            }
                            $scope.rulesListObj[ruleSetId].push(data);
                            workflowTaksHelper(ruleSetId);
                            updateRoutingRuleStatus(ruleSetId);
                            updateRoutingRuleAuxiliaryActionNames(ruleSetId);
                            workflowStepsHelper(ruleSetId);
                            $ioAlert.show('', 'Routing Rule created successfully', 'success');
                        }
                    }, function(error) {
                        console.log("error saving routing rule");
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    WorkflowsService.updateRoutingRules(formObj, $scope.scheduledRouting).then(function(data) {
                        if (data) {
                            for (var i = 0, len = $scope.rulesListObj[ruleSetId].length; i < len; i++) {
                                if (data.id == $scope.rulesListObj[ruleSetId][i].id) {
                                    $scope.rulesListObj[ruleSetId][i] = data;
                                }
                            }
                            workflowTaksHelper(ruleSetId);
                            updateRoutingRuleStatus(ruleSetId);
                            updateRoutingRuleAuxiliaryActionNames(ruleSetId);
                            workflowStepsHelper(ruleSetId);
                            $ioAlert.show('', 'Routing Rule updated successfully', 'success');
                        }
                    }, function(error) {
                        console.log("error saving routing rule");
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
                //updateWorkflowGraph();
            } else{
                $scope.deleteRoutingRule(ruleSetId, routingRule.id);
            }
        }, function(cancel) {
            console.log("cancelled");
        });
    };

    //Add/edit routing condtion
    $scope.addCondition = function(ruleSetId, routingCondition) {
        var isNew = (routingCondition) ? false : true;

        var modalObj = $modal.open(
            ModalService.returnModalType('createRoutingCondition', {
                data: {
                    ruleSetId: ruleSetId,
                    routingCondition: routingCondition,
                    routingRules: $scope.rulesListObj[ruleSetId],
                    tapIORuleSets: $scope.tapIORuleSets
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if(formObj){
                if (isNew) {
                    WorkflowsService.addRoutingCondition(formObj).then(function(data) {
                        if (data) {
                            if (!$scope.routingConditionsObj[ruleSetId]) {
                                $scope.routingConditionsObj[ruleSetId] = [];
                            }
                            var obj = _.find($scope.tapIORuleSets, function(ruleSet) {
                                return ruleSet.id == data.rule_set_id
                            });
                            data.rule_set_name = obj.name;
                            $scope.routingConditionsObj[ruleSetId].push(data);
                            $ioAlert.show('', 'Routing Condition created successfully', 'success');
                        }
                    }, function(error) {
                        console.log("error saving routing condition");
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    WorkflowsService.updateRoutingCondition(formObj).then(function(data) {
                        if (data) {
                            for (var i = 0, len = $scope.routingConditionsObj[ruleSetId].length; i < len; i++) {
                                if (data.id == $scope.routingConditionsObj[ruleSetId][i].id) {
                                    var obj = _.find($scope.tapIORuleSets, function(ruleSet) {
                                        return ruleSet.id == data.rule_set_id
                                    });
                                    data.rule_set_name = obj.name;
                                    $scope.routingConditionsObj[ruleSetId][i] = data;
                                }
                            }
                            $ioAlert.show('', 'Routing Condition updated successfully', 'success');
                        }
                    }, function(error) {
                        console.log("error saving routing condition");
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
                //updateWorkflowGraph();
            } else{
                $scope.deleteRoutingCondition(ruleSetId,routingCondition.id);
            }
        }, function(cancel) {
            console.log("cancelled");
        });
    };

    //Add/edit workflow task
    $scope.addWorkflowTask = function(ruleSetId, routingRuleId, taskId) {
        var isNewTask, taskObj;
        if (taskId) {
            isNewTask = false;
            for (var i = 0, len = $scope.workflowTasks.length; i < len; i++) {
                if ($scope.workflowTasks[i].id == taskId) {
                    taskObj = $scope.workflowTasks[i];
                }
            }
        } else {
            isNewTask = true;
        }

        var modalObj = $modal.open(
            ModalService.returnModalType('createWorkflowTask', {
                data: {
                    workflowId: $scope.workflowId,
                    task: taskObj,
                    workflowActions: $scope.workflowActions,
                    routingRuleId: routingRuleId,
                    tasksList: $scope.tasksList
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if(!isNewTask && !formObj){
                WorkflowsService.deleteWorkflowTask(taskId).then(function(data) {
                    for (var i = 0, len = $scope.workflowTasks.length; i < len; i++) {
                        if ($scope.workflowTasks[i].id == taskId) {
                            $scope.workflowTasks.splice(i, 1);
                            workflowTaksHelper(ruleSetId);
                            break;
                        }
                    }
                    $ioAlert.show('', 'Workflow Task deleted successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
            } else if (isNewTask) {
                WorkflowsService.addWorkflowTask(formObj).then(function(data) {
                    for (var i = 0, len = $scope.tasksList.length; i < len; i++) {
                        if ($scope.tasksList[i].id == data.task_id) {
                            data.name = $scope.tasksList[i].name;
                            break;
                        }
                    }
                    $scope.workflowTasks.push(data);
                    workflowTaksHelper(ruleSetId);
                    $ioAlert.show('', 'Workflow Task created successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', error[0], 'error');
                    console.log("error saving workflow task");
                });
            } else {
                WorkflowsService.updateWorkflowTask(formObj).then(function(data) {
                    if (data) {
                        for (var i = 0, len = $scope.workflowTasks.length; i < len; i++) {
                            if ($scope.workflowTasks[i].id == data.id) {
                                $scope.workflowTasks[i] = data;
                                workflowTaksHelper(ruleSetId);
                            }
                        }
                        $ioAlert.show('', 'Workflow task updated successfully', 'success');
                    }
                }, function(error) {
                    $ioAlert.show('Error!', error[0], 'error');
                    console.log("error updating workflow task");
                });
            }
            //updateWorkflowGraph();
        }, function(cancel) {
            console.log("cancel");
        });
    };

    //Add/edit workflow task interlocking
    $scope.addWorkflowTaskInterlocking = function(ruleSetId, routingRuleId, interlockingId) {
        var isNewInterlocking, interlockingObj;
        if (interlockingId) {
            isNewInterlocking = false;
            for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
                if ($scope.workflowTaskInterlockings[i].id == interlockingId) {
                    interlockingObj = $scope.workflowTaskInterlockings[i];
                }
            }
        } else {
            isNewInterlocking = true;
        }

        var modalObj = $modal.open(
            ModalService.returnModalType('createWorkflowTaskInterlocking', {
                data: {
                    workflowId: $scope.workflowId,
                    interlocking: interlockingObj,
                    workflowActions: $scope.workflowActions,
                    routingRuleId: routingRuleId,
                    workflowTasks: $scope.workflowTasks
                }
            })
        );

        modalObj.result.then(function(interlockingObj) {
            if(!isNewInterlocking && !interlockingObj){
                WorkflowsService.deleteWorkflowTaskInterlocking(interlockingId).then(function(data) {
                    for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
                        if ($scope.workflowTaskInterlockings[i].id == interlockingId) {
                            $scope.workflowTaskInterlockings.splice(i, 1);
                            workflowTaksHelper(ruleSetId);
                            break;
                        }
                    }
                    $ioAlert.show('', 'Workflow Task Interlocking deleted successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
            
            }else if (isNewInterlocking) {
                WorkflowsService.addWorkflowTaskInterlocking(interlockingObj).then(function(data) {
                    for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
                        if ($scope.workflowTaskInterlockings[i].id == data.task_id) {
                            data.name = $scope.workflowTaskInterlockings[i].name;
                            break;
                        }
                    }

                    $scope.workflowTaskInterlockings.push(data);
                    workflowTaksHelper(ruleSetId);
                    $ioAlert.show('', 'Interlocking Rule created successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', error, 'error');
                    console.log("error saving interlocking rule");
                });
            } else {
                WorkflowsService.updateWorkflowTaskInterlocking(interlockingObj).then(function(data) {
                    if (data) {
                        for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
                            if ($scope.workflowTaskInterlockings[i].id == data.id) {
                                $scope.workflowTaskInterlockings[i] = data;
                                workflowTaksHelper(ruleSetId);
                            }
                        }
                        $ioAlert.show('', 'Interlocking rule updated successfully', 'success');
                    }
                }, function(error) {
                    $ioAlert.show('Error!', error, 'error');
                    console.log("error saving interlocking rule");
                });
            }
            //updateWorkflowGraph();
        }, function(cancel) {
            console.log("cancel");
        });
    };

    /*
     * Delete Routing Rule Set
     */
    $scope.deleteRuleSet = function(ruleId) {
        if (ruleId) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this routing rule set?'
            }).then(function() {
                WorkflowsService.deleteRoutingRuleSet(ruleId).then(function(data) {
                    if (data.errors) {
                        $ioAlert.show('Error!', 'RuleSet was not deleted. Please delete Rules first!', 'error');
                    } else {
                        for (var i = 0, len = $scope.ruleSets.length; i < len; i++) {
                            if ($scope.ruleSets[i].id == ruleId) {
                                $scope.ruleSets.splice(i, 1);
                                break;
                            }
                        }
                        $ioAlert.show('', 'RuleSet deleted successfully', 'success');
                        //updateWorkflowGraph();
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })

            }, function() {
                console.log("cancel")
            })
        }
    };

    /*
     * delete Routing rule
     */
    $scope.deleteRoutingRule = function(ruleId, listId) {
        if (ruleId && listId) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this routing rule?'
            }).then(function() {
                WorkflowsService.deleteRoutingRule(listId).then(function(data) {
                    var message = '';
                    var errors = data.errors;
                    if (errors) {
                        errors = errors[0];
                        if(errors.indexOf('task_interlocking') !== -1) {
                            message = 'Please delete Interlocking Rule first!';
                        }else if(errors.indexOf('routing_condition') !== -1) {
                            message = 'Please delete Rule Condition first!';
                        }
                        $ioAlert.show('Error!', 'Rule was not deleted. ' + message, 'error');
                    } else {
                        for (var i = 0, len = $scope.rulesListObj[ruleId].length; i < len; i++) {
                            if (listId == $scope.rulesListObj[ruleId][i].id) {
                                $scope.rulesListObj[ruleId].splice(i, 1);
                                break;
                            }
                        }
                        $ioAlert.show('', 'Rule deleted successfully', 'success');
                        //updateWorkflowGraph();
                    }
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });

            }, function() {
                console.log("cancel")
            })
        }
    };

    /*
     * Delete Routing Condition
     */
    $scope.deleteRoutingCondition = function(ruleId, conditionId) {
        if (ruleId && conditionId) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this routing condition?'
            }).then(function() {
                WorkflowsService.deleteRoutingCondition(conditionId).then(function(data) {
                    for (var i = 0, len = $scope.routingConditionsObj[ruleId].length; i < len; i++) {
                        if (conditionId == $scope.routingConditionsObj[ruleId][i].id) {
                            $scope.routingConditionsObj[ruleId].splice(i, 1);
                            break;
                        }
                    }
                    $ioAlert.show('', 'Rule Condition deleted successfully', 'success');
                    //();
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
            }, function() {
                console.log("cancel")
            })
        }
    };

    $scope.deleteWorkflowTask = function(ruleId, listId, taskId) {
        if (ruleId && taskId) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this workflow task?'
            }).then(function() {
                WorkflowsService.deleteWorkflowTask(taskId).then(function(data) {
                    for (var i = 0, len = $scope.workflowTasks.length; i < len; i++) {
                        if ($scope.workflowTasks[i].id == taskId) {
                            $scope.workflowTasks.splice(i, 1);
                            workflowTaksHelper(ruleId);
                            break;
                        }
                    }
                    $ioAlert.show('', 'Workflow Task deleted successfully', 'success');
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
                //updateWorkflowGraph();
            }, function() {
                console.log("cancel")
            })
        }
    };

    $scope.deleteWorkflowTaskInterlocking = function(ruleId, listId, interlockingId) {
        if (ruleId && interlockingId) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this workflow task interlocking?'
            }).then(function() {
                WorkflowsService.deleteWorkflowTaskInterlocking(interlockingId).then(function(data) {
                    for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
                        if ($scope.workflowTaskInterlockings[i].id == interlockingId) {
                            $scope.workflowTaskInterlockings.splice(i, 1);
                            workflowTaksHelper(ruleId);
                            break;
                        }
                    }
                    $ioAlert.show('', 'Workflow Task Interlocking deleted successfully', 'success');
                    //updateWorkflowGraph();
                }, function(error) {
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                })
            }, function() {
                console.log("cancel")
            })
        }
    };

    $scope.showAllTasks = function() {
        $state.go('workflowTask', {
            'id': $scope.workflowId
        });
    };

    $scope.showVisualWorkflow = function() {
        $state.go('wflowchart', {
            'id': $scope.workflowId
        });
    };

    /*
     * EVERYTHING RELATED TO MXGRAPH STARTS HERE
     */

    $scope.showEditor = function() {
        if ($scope.workflowInfoObj) {
            $modal.open({
                controller: 'WorkflowGraphCtrl',
                template: '<io-graph workflow-obj="workflowObj" workflow-save="workflowSave(workflowData);" delete-cell="deleteCell(cellObj)" close-workflow="closeWorkflow()"></io-graph><div class="loadingbackground wf-graph-loader"  ng-show="loadInProgress"><div id="io-loading-bar" class="loading-wheel"></div><h4 class="loadingheading" >Saving Workflow</h4></div>',
                backdrop: 'static',
                size: 'full',
                windowClass: 'smooth library-modal modal-overflow in',
                resolve: {
                    workflowObj: function() {
                        return {
                            "workflowInfo": $scope.workflowInfoObj,
                            "workflowStatus": $scope.statusList,
                            "workflowActions": $scope.workflowActions,
                            "routingRuleSets": $scope.ruleSets,
                            "workflowTasks": $scope.workflowTasks,
                            "tasksList": $scope.tasksList
                        };
                    }
                },
            }).result.then(function() {
                getWorkflowInfo();
            }, function(cancel) {

            });
        } else {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        }
    }

    var getRoutingRulesAndConditions = function() {
        _.each($scope.ruleSets, function(routingRuleSetObj) {
            routingRuleSetObj.routingRules = [];
            routingRuleSetObj.routingConditions = [];
            WorkflowsService.getRoutingRules(routingRuleSetObj.id).then(function(success) {
                var routingRules = WorkflowsService.routingRulesList;
                if (routingRules && routingRules.length > 0) {
                    var ruleSetObj = _.find($scope.ruleSets, { id: routingRules[0].routing_rule_set_id });
                    ruleSetObj.routingRules = routingRules;
                }
            }, function(error) {
                console.log("error loading routing rules list");
            });
            WorkflowsService.getRoutingConditions(routingRuleSetObj.id).then(function(success) {
                var routingConditions = WorkflowsService.routingConditions;
                if (routingConditions && routingConditions.length > 0) {
                    var ruleSetObj = _.find($scope.ruleSets, { id: routingConditions[0].routing_rule_set_id });
                    ruleSetObj.routingConditions = routingConditions;
                }
            }, function(error) {
                console.log("error loading routing conditions list");
            });
        });
    }

    /*
     *   get the current active user details
     */
    var getCurrentUser = function() {
        UserService.getUser($rs.userRole.id).then(function() {
            var currentUser = UserService.user;
            var index = authorizedUsers.indexOf(currentUser.email);
            if (index == -1) {
                $scope.showGraphicalWorkflow = false;
            } else {
                $scope.showGraphicalWorkflow = true;
            }
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }

    /*
    * Handle get instance lock configuration
    */
    var getInstanceLockConfig = function() {
        FormService.getInstanceLockConfig().then(function(data) {
            if(data.instanceLocked) {
                $scope.disableBtnAction = true;
            } else {
                $scope.disableBtnAction = false;
            }

        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    }
    UserService.adjustStickyHeaderWindowResize();


    /*
     * EVERYTHING RELATED TO MXGRAPH ENDS HERE
     */

    $scope.init = function() {
        if ($scope.workflowId) {
            ClusterService.initCluster($rs.userRole, 'hidden');
            getWorkflowInfo();
            getTapIORuleSets();
            getTasksList();
            getCurrentUser();
            getInstanceLockConfig();
            UserService.adjustStickyHeader();
        }
    };
    $scope.init();
}

WfFullViewController.$inject = ['$state', '$scope', 'WorkflowsService', 'TaskService', '$stateParams', '$window', '$rootScope', '$modal', 'ModalService', 'StepGroupService', '$ioAlert', 'TapIoRuleSetService', 'UserService'];

function WfFullViewController($state, $scope, WorkflowsService, TaskService, $stateParams, $window, $rootScope, $modal, ModalService, StepGroupService, $ioAlert, TapIoRuleSetService, UserService) {
    $scope.workflowId = $stateParams.id;
    $scope.workflow = {};
    $scope.edgeColorList = [];
    $scope.edgeColorIndex = 0;
    $scope.workflowTaskInterlockings = [];
    $scope.ruleSets = [];
    $scope.scheduledRouting = false;
    $scope.workflowSortBy = "";
    $scope.workflowSearch = {
        "byVal": "Action",
        "keyVal": ""
    };
    $scope.hideSearch = true;

    var getOrderStatuses = function() {
        WorkflowsService.getOrderStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.orderStatusList;
            setStatusName();
        }, function(error) {
            console.log("error loading order statuses");
        });
    };

    var getClientStatuses = function() {
        WorkflowsService.getClientStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.clientStatusList;
            setStatusName();
        }, function(error) {
            console.log("error loading client statuses");
        });
    };

    //If the type of workflow is lineItem, get Line Item Status List
    var getLineItemStatuses = function() {
        WorkflowsService.getLineItemStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.lineItemStatusList;
            setStatusName();
        }, function(error) {
            console.log("error loading lineitem statuses");
        });
    };

    var getFlightStatuses = function() {
        WorkflowsService.getFlightStatuses().then(function(success) {
            $scope.statusList = WorkflowsService.flightStatusList;
            setStatusName();
        }, function(error) {
            console.log("error loading flight statuses");
        });
    };

    var setStatusName = function() {
        _.each($scope.ruleSets, function(ruleSet) {
            ruleSet.status_name = "";
            if (ruleSet.status_ids) {
                let first = true;
                _.each(ruleSet.status_ids, function (statusId) {
                    const obj = _.find($scope.statusList, {
                        id: statusId
                    });
                    if (obj) {
                        if (first) {
                            first = false;
                        } else {
                            ruleSet.status_name += ', ';
                        }
                        ruleSet.status_name += obj.name;
                    }
                });
            }
            _.each(ruleSet.routing_rules, function(rule) {
                rule.status_name = "";
                if (rule.status_id) {

                    var statusObj = _.find($scope.statusList, {
                        id: rule.status_id
                    });
                    if (statusObj) {
                        rule.status_name = statusObj.name;
                    }
                }
            });
        });
    }

    var getSteps = function() {
        StepGroupService.getStepsXrefs({
            'workflowStepGroupId': $scope.workflow.workflow_step_group_id
        }).then(function(response) {
            $scope.steps = response.workflowStepGroupXrefs;
            _.each($scope.ruleSets, function(ruleSet) {
                _.each(ruleSet.routing_rules, function(rule) {
                    if (rule.workflow_step_id) {
                        rule.step = _.find($scope.steps, function(step) {
                            return step.workflow_step_id == rule.workflow_step_id;
                        });
                    }
                });
            })
        }, function(error) {})
    };

    var getFullWorkflow = function() {
        $scope.ruleSets = [];
        WorkflowsService.getFullWorkflow($scope.workflowId).then(function(response) {
            $scope.workflow = angular.copy(response);
            $scope.ruleSets = angular.copy(response.routing_rule_sets);
            if ($scope.workflow.workflow_type_name == 'LineItem') {
                getLineItemStatuses();
            } else if ($scope.workflow.workflow_type_name == 'Order') {
                getOrderStatuses();
            } else if ($scope.workflow.workflow_type_name == 'Client') {
                getClientStatuses();
            } else {
                getFlightStatuses();
            }
            if ($scope.workflow.workflow_step_group_id) {
                getSteps();
            }
            getWorkflowActions();
        });
    };

    var getWorkflowActions = function() {
        WorkflowsService.getActiveWorkflowActions().then(function(success) {
            $scope.workflowActions = WorkflowsService.workflowActions;
            for (var i = 0, iSize = $scope.ruleSets.length; i < iSize; i++) {
                for (var j = 0, jSize = $scope.workflowActions.length; j < jSize; j++) {
                    if ($scope.ruleSets[i].workflow_action_id == $scope.workflowActions[j].id) {
                        $scope.ruleSets[i].workflow_action_name = $scope.workflowActions[j].name;
                        break;
                    }
                }
            }
            //getWorkflowTaskList();
            getWorkflowTaskInterlockings();
        }, function(error) {
            console.log("error loading workflow actions list");
        });
    };

    var getWorkflowTaskInterlockings = function() {
        WorkflowsService.getWorkflowTaskInterlockingsList($scope.workflowId).then(function(response) {
            $scope.workflowTaskInterlockings = [];
            if (response.workflowTaskInterlockings) {
                $scope.workflowTaskInterlockings = response.workflowTaskInterlockings;
            }
            getWorkflowTaskList();
        }, function(error) {
            console.log("error loading task inter locking list");
        });
    };

    var getWorkflowTaskList = function() {
        WorkflowsService.getWorkflowTasksList($scope.workflowId).then(function(success) {
            $scope.workflowTasks = WorkflowsService.workflowTaskList;
            if (!$scope.workflowTasks) {
                $scope.workflowTasks = [];
            } else {
                _.each($scope.ruleSets, function(ruleSet) {
                    if (ruleSet.linking_workflow_tasks.length) {
                        _.each(ruleSet.linking_workflow_tasks, function(wfTask) {
                            _.each($scope.workflowTasks, function(task) {
                                if (task.id == wfTask.id) {
                                    if (!task.ruleSetArr) {
                                        task.ruleSetArr = [];
                                    }
                                    task.ruleSetArr.push({
                                        "id": ruleSet.id,
                                    });
                                }
                            });
                        });
                    }
                });
                _.each($scope.ruleSets, function(ruleSet) {
                    _.each(ruleSet.routing_rules, function(rule) {
                        rule.tasks = [];
                        _.each($scope.workflowTasks, function(task) {
                            if (rule.id == task.routing_rule_id) {
                                rule.tasks.push({
                                    "taskId": task.id,
                                    "taskName": task.definition,
                                    "interlockings": [],
                                    "interlockingClass": "",
                                    "ruleSetArr": task.ruleSetArr
                                });
                            }
                        });
                        _.each($scope.workflowTaskInterlockings, function(lock) {
                            _.each(lock.selected_workflow_task_ids, function(lockTaskId, index) {
                                var taskObj = _.find(rule.tasks, {
                                    "taskId": lockTaskId
                                });
                                if (taskObj) {
                                    taskObj.interlockings.push(lock);
                                    taskObj.interlockingClass = taskObj.interlockingClass + " lock" + lock.id;
                                }
                            });
                        });
                    });
                });
            }
            _.each($scope.ruleSets, function(ruleSet) {
                if (ruleSet.routing_conditions) {
                    var io_rule = [];
                    _.each(ruleSet.routing_conditions, function(condition) {
                        if (condition.true_routing_rule_id) {
                            condition['trueRule'] = _.find(ruleSet.routing_rules, function(n) {
                                return n.id == condition.true_routing_rule_id;
                            });
                            if (io_rule.indexOf(condition['trueRule'].id) < 0) {
                                io_rule.push(condition['trueRule'].id);
                            }

                        }
                        if (condition.false_routing_rule_id) {
                            condition['falseRule'] = _.find(ruleSet.routing_rules, function(n) {
                                return n.id == condition.false_routing_rule_id;
                            });
                            if (io_rule.indexOf(condition['falseRule'].id) < 0) {
                                io_rule.push(condition['falseRule'].id);
                            }
                        }
                    });
                    _.remove(ruleSet.routing_rules, function(n) {
                        return io_rule.indexOf(n.id) > -1;
                    })
                }
            });

            $rootScope.$broadcast("ruleSetChange", $scope.ruleSets.length);
        }, function(error) {
            console.log("error loading tasks list");
        });
    };

    $scope.backToWorkflow = function() {
        $state.go('workflowView', {
            'id': $scope.workflowId
        });
    }

    var getTasksList = function() {
        TaskService.getTasksList().then(function(success) {
            $scope.tasksList = TaskService.tasksList;
        });
    };

    var getTapIORuleSets = function() {
        TapIoRuleSetService.getRuleSets().then(function(success) {
            $scope.tapIORuleSets = TapIoRuleSetService.ruleSets;
        }, function(error) {
            console.log("error loading ruleSets list");
        });
    };

    $scope.addEditRuleSet = function(ruleSet) {
        var isNew = (ruleSet) ? false : true;

        var modalObj = $modal.open(
            ModalService.returnModalType('addRoutingRuleSet', {
                data: {
                    isNew: isNew,
                    ruleSet: ruleSet,
                    workflowActions: $scope.workflowActions,
                    workflowId: $scope.workflowId,
                    statusList: $scope.statusList,
                    scheduledRouting: $scope.scheduledRouting
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if (formObj) {
                if (isNew) {
                    WorkflowsService.addRoutingRuleSet(formObj, $scope.scheduledRouting).then(function(data) {
                        /*if (data) {
                            $scope.ruleSets.push(data);
                            workflowActionsHelpr();
                            updateRoutingRuleSetStatus();
                            $ioAlert.show('', 'Routing Rule Set Added successfully', 'success');
                        }*/
                        $ioAlert.show('', 'Routing Rule Set Added successfully', 'success');
                        getFullWorkflow();
                    }, function(error) {
                        console.log("Error saving routing rule set: " + error);
                        $ioAlert.show('Error!', error, 'error');
                    })
                } else {
                    WorkflowsService.updateRoutingRuleSet(formObj, $scope.scheduledRouting).then(function(data) {
                        /*for (var i = 0, len = $scope.ruleSets.length; i < len; i++) {
                            if (data.id == $scope.ruleSets[i].id) {
                                $scope.ruleSets[i] = data;
                                workflowActionsHelpr();
                                updateRoutingRuleSetStatus();
                                $ioAlert.show('', 'Routing Rule Set updated successfully', 'success');
                            }
                        }*/
                        $ioAlert.show('', 'Routing Rule Set updated successfully', 'success');
                        getFullWorkflow();
                    }, function(error) {
                        console.log("Error updating routing rule set: " + error);
                        $ioAlert.show('Error!', error, 'error');
                    })
                }
            } else {
                getFullWorkflow();
            }
        }, function(cancel) {
            //console.log("cancel");
        })
    };

    /*
     * ADD EDIT ROUTING RULE
     */
    $scope.addRule = function(ruleSetId, routingRule) {
        var isNew = (routingRule) ? false : true;

        var modalObj = $modal.open(
            ModalService.returnModalType('createRoutingRule', {
                data: {
                    ruleSetId: ruleSetId,
                    routingRule: routingRule,
                    statusList: $scope.statusList,
                    workflowActions: $scope.workflowActions,
                    workflowTypeName: $scope.workflow.workflow_type_name,
                    scheduledRouting: $scope.scheduledRouting,
                    steps: $scope.steps,
                    worflowStepId: $scope.workflowStepId
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if (formObj) {
                formObj.defaultRule = formObj.defaultRule ? 'yes' : 'no';
                if (isNew) {
                    WorkflowsService.addRoutingRules(formObj, $scope.scheduledRouting).then(function(data) {
                        if (data) {
                            getFullWorkflow();
                            $ioAlert.show('', 'Routing Rule created successfully', 'success');
                        }
                    }, function(error) {
                        console.log("error saving routing rule");
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    WorkflowsService.updateRoutingRules(formObj, $scope.scheduledRouting).then(function(data) {
                        if (data) {
                            getFullWorkflow();
                            $ioAlert.show('', 'Routing Rule updated successfully', 'success');
                        }
                    }, function(error) {
                        console.log("error saving routing rule");
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
            } else {
                getFullWorkflow();
            }

        }, function(cancel) {
            //console.log("cancelled");
        });
    };

    /*
     * Add EDIT ROUTING CONDITION
     */
    $scope.addCondition = function(ruleSet, routingCondition) {
        var isNew = (routingCondition) ? false : true;

        var modalObj = $modal.open(
            ModalService.returnModalType('createRoutingCondition', {
                data: {
                    ruleSetId: ruleSet.id,
                    routingCondition: routingCondition,
                    routingRules: ruleSet.routing_rules,
                    tapIORuleSets: $scope.tapIORuleSets
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if (formObj) {
                if (isNew) {
                    WorkflowsService.addRoutingCondition(formObj).then(function(data) {
                        if (data) {
                            getFullWorkflow();
                            $ioAlert.show('', 'Routing Condition created successfully', 'success');
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    WorkflowsService.updateRoutingCondition(formObj).then(function(data) {
                        if (data) {
                            getFullWorkflow();
                            $ioAlert.show('', 'Routing Condition updated successfully', 'success');
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
            } else {
                getFullWorkflow();
            }
        }, function(cancel) {
            //console.log("cancelled");
        });
    };

    $scope.addWorkflowTaskInterlocking = function(ruleSetId, routingRuleId, interlockingId) {
        var isNewInterlocking, interlockingObj;
        if (interlockingId) {
            isNewInterlocking = false;
            for (var i = 0, len = $scope.workflowTaskInterlockings.length; i < len; i++) {
                if ($scope.workflowTaskInterlockings[i].id == interlockingId) {
                    interlockingObj = $scope.workflowTaskInterlockings[i];
                }
            }
        } else {
            isNewInterlocking = true;
        }

        var modalObj = $modal.open(
            ModalService.returnModalType('createWorkflowTaskInterlocking', {
                data: {
                    workflowId: $scope.workflowId,
                    interlocking: interlockingObj,
                    workflowActions: $scope.workflowActions,
                    routingRuleId: routingRuleId,
                    workflowTasks: $scope.workflowTasks
                }
            })
        );

        modalObj.result.then(function(interlockingObj) {
            if (isNewInterlocking) {
                WorkflowsService.addWorkflowTaskInterlocking(interlockingObj).then(function(data) {
                    $ioAlert.show('', 'Interlocking Rule created successfully', 'success');
                    getFullWorkflow();
                }, function(error) {
                    $ioAlert.show('Error!', error, 'error');
                    console.log("error saving interlocking rule");
                });
            } else {
                if (interlockingObj) {
                    WorkflowsService.updateWorkflowTaskInterlocking(interlockingObj).then(function(data) {
                        if (data) {
                            getFullWorkflow();
                            $ioAlert.show('', 'Interlocking rule updated successfully', 'success');
                        }
                    }, function(error) {
                        $ioAlert.show('Error!', error, 'error');
                        console.log("error saving interlocking rule");
                    });
                } else {
                    getFullWorkflow();
                }

            }
        }, function(cancel) {
            console.log("cancel");
        });
    };

    var taskCreate = $rootScope.$on('createTask', function(event, routingRuleId, taskId) {
        var isNewTask = true,
            taskObj;
        if (taskId) {
            isNewTask = false;
            _.each($scope.workflowTasks, function(task) {
                if (taskId == task.id) {
                    taskObj = task;
                }
            });
        }
        var modalObj = $modal.open(
            ModalService.returnModalType('createWorkflowTask', {
                data: {
                    workflowId: $scope.workflowId,
                    task: taskObj,
                    workflowActions: $scope.workflowActions,
                    routingRuleId: routingRuleId,
                    tasksList: $scope.tasksList
                }
            })
        );

        modalObj.result.then(function(formObj) {
            if (formObj) {
                if (isNewTask) {
                    WorkflowsService.addWorkflowTask(formObj).then(function(data) {
                        getFullWorkflow();
                        $ioAlert.show('', 'Workflow Task created successfully', 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                } else {
                    WorkflowsService.updateWorkflowTask(formObj).then(function(data) {
                        getFullWorkflow();
                        $ioAlert.show('', 'Workflow task updated successfully', 'success');
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }

            } else {
                getFullWorkflow();
            }
        }, function(cancel) {
            //console.log("cancel");
        });
    });



    var ruleSetEdit = $rootScope.$on('EDIT_RULE_SET', function(event, ruleSetId) {
        $scope.addEditRuleSet(ruleSetId);
    });

    var ruleCreate = $rootScope.$on('CREATE_RULE', function(event, ruleSetId, rule) {
        $scope.addRule(ruleSetId, rule);
    });

    var conditionCreate = $rootScope.$on('CREATE_CONDITION', function(event, ruleSetId, condition) {
        //var checkRuleSet = _.find($scope.ruleSets, function(o) { return o.id == ruleSetId });
        var ruleSet = _.find($scope.workflow.routing_rule_sets, function(o) {
            return o.id == ruleSetId
        });
        if (condition || (ruleSet.routing_rules && ruleSet.routing_rules.length)) {
            $scope.addCondition(ruleSet, condition);
        } else {
            $ioAlert.show('Error!', 'Please create a rule Set ', 'error');
        }
    });

    var createWorkflowTaskInterlocking = $rootScope.$on('createWorkflowTaskInterlocking', function(event, ruleSetId, routingRuleId, interlockingId) {
        if (ruleSetId && routingRuleId) {
            $scope.addWorkflowTaskInterlocking(ruleSetId, routingRuleId, interlockingId);
        }
    });

    $scope.$on('$destroy', function() {
        taskCreate();
        ruleSetEdit();
        ruleCreate();
        conditionCreate();
        createWorkflowTaskInterlocking();
    });
    UserService.adjustStickyHeaderWindowResize();
    var init = function() {
        //getWfCoordinates();
        getFullWorkflow();
        getTasksList();
        getTapIORuleSets();
        UserService.adjustStickyHeader();
    };
    init();
}

/*
 * Task properties and new task creation
 */
TaskPropertiesController.$inject = ['$scope', '$rootScope', 'ClusterService', 'TaskService', 'DateRangeService', 'QueuesService', 'IntegrationsService', '$ioAlert', 'UserService', '$timeout'];

function TaskPropertiesController($scope, $rs, ClusterService, TaskService, DateRangeService, QueuesService, IntegrationsService, $ioAlert, UserService, $timeout) {
    $scope.taskObj = {};
    $scope.newTaskObj = {};
    var workflowObj = $scope.$parent.$parent.$parent.workflowObj;
    var cell = $scope.$parent.$parent.$parent.cellObj;
    $scope.taskText = "Create New Workflow Task";
    $scope.taskObj.statusId = cell.parent.statusId;
    $scope.tasksList = workflowObj.tasksList;
    $scope.workflowActions = workflowObj.workflowActions;
    $scope.workflowStatus = workflowObj.workflowStatus;
    $scope.newTask = false;
    $scope.disableIncoming = false;
    $scope.newTaskObj.useBusinessDays = 1;
    $scope.isBeforeDisabled = false;
    var beforeValues = ["3", "4", "6", "7"];
    $scope.queuesList = [];
    $scope.refTables = [];
    $scope.vendorsList = [];
    $scope.dueDaysFromList = [];
    $scope.eventsList = [];
    $scope.assigneeList = ["create_order_user_id", "campaign_manager_id"];
    $scope.btnText = "Save";
    $scope.workflowTasksTemplate = addTaskHtmlUrl;
    /*
     * Helper function to populate the drop downs
     * @param: arr - Array list of the dropdown
     * @param: obj - to be populated object
     */
    function populateData_helper(arr, obj) {
        return _.find(arr, function(item) {
            return item.id == obj.id
        })
    }

    //add task to the workflow
    $scope.addTask = (fieldsForm) => {
        if (fieldsForm.$valid) {
            $scope.$parent.$parent.$parent.show = false;
            $rs.$broadcast('addTaskToWorkflow', $scope.taskObj, cell);
            // $scope.$parent.$parent.$parent.formHandler($scope.taskObj, cell);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };

    //create a new task
    $scope.addNewTask = () => {
        $scope.newTask = true;
        $scope.newTaskObj.validate = true;
        ClusterService.initCluster($rs.userRole, 'singleSelect').then(function() {
            getReferenceTables();
            getVendorsList();
            getQueuesList(ClusterService.clusterIds[0]);
            getEventNames();
            getDueDateDependencies();
            getAllUsers(ClusterService.clusterIds[0]);
        });
    };

    /*
     * Helper function to disable enable before and after radio buttons
     */
    $scope.updateBeforeAfter = function() {
        if (_.indexOf(beforeValues, $scope.newTaskObj.dueDateDependencyId) > -1) {
            $scope.isBeforeDisabled = false;
        } else {
            $scope.isBeforeDisabled = true;
        }
    }

    $scope.resetTask = () => {
        $scope.newTask = false;
    }

    /*
    * Handle cancel modal
    */
    $scope.cancel = () => {
        var myElement = angular.element(document.querySelector( '#fieldForm' ));
        myElement.addClass('fieldFormInactive');
        $timeout(function () {
            $scope.$parent.$parent.$parent.show = false;
        }, 1000);
    };

    //save new task
    $scope.saveTask = function(taskForm) {
        if (taskForm.$valid) {
            var params = JSON.parse(JSON.stringify($scope.newTaskObj));

            if (params.rejectable == true) {
                params.rejectable = 1;
            } else {
                params.rejectable = 0;
            }

            if (params.timeTracking == true) {
                params.timeTracking = 1;
            } else {
                params.timeTracking = 0;
            }

            if (params.timeTrackingRequired == true) {
                params.timeTrackingRequired = 1;
            } else {
                params.timeTrackingRequired = 0;
            }

            if (params.linkServiceMapper == true) {
                params.linkServiceMapper = 1;
            } else {
                params.linkServiceMapper = 0;
            }

            if (params.validate == true) {
                params.validate = "yes";
            } else {
                params.validate = "no";
            }
            if (params.eventNames) {
                params.eventNames = JSON.stringify(params.eventNames);
            }
            if (params.escalatable == true) {
                params.escalatable = 1;
            } else {
                params.escalatable = 0;
            }

            TaskService.saveTask(params).then(function(success) {
                $ioAlert.show("Success!", "Task " + success.task.definition + " has been created.", 'success');
                $scope.tasksList.push(success.task);
                $scope.newTaskObj = {
                    "taskId": success.task.id
                };
                $scope.newTask = false;
            }, function(error) {
                $ioAlert.show("Error!", "An error occurred saving the task", 'error');
            });

        } else {
            $ioAlert.show("Validation Error!", "Please fill in the required fields", 'error');
        }
    };

    /*
     *  get queues list for new task
     */
    var getQueuesList = (clusterId) => {
        QueuesService.getQueues(clusterId).then(function(success) {
            $scope.queuesList = QueuesService.queues;
        }, function(error) {
            console.log("error loading queues list");
        });
    };

    /*
     *  get reference tables for new task
     */
    var getReferenceTables = () => {
        TaskService.getReferenceTables().then(function(data) {
            $scope.refTables = data;
        }, function(error) {
            console.log("error loading reference tables");
        });
    };

    /*
     *  get vendors list for new task
     */
    var getVendorsList = () => {
        TaskService.getVendorsList().then(function(data) {
            $scope.vendorsList = data;
        }, function(error) {
            console.log("error loading reference tables");
        });
    };

    /*
     *  get all events for task
     */
    var getEventNames = () => {
        IntegrationsService.getEventNames().then(function(data) {
            $scope.eventsList = data;
        }, function() {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        });
    };

    /*
     *  get due date dependencies
     */
    var getDueDateDependencies = () => {
        TaskService.getDueDateDependencies().then(function(data) {
            $scope.dueDaysFromList = data;
        }, function(error) {
            $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
        })
    }

    /*
    * Handle Get all users
    */
    var getAllUsers = function(clusterId){
        UserService.getUsers(clusterId).then(function(success) {
            $scope.allUsers = UserService.users;
        }, function() {
            console.log("Error getting users.");
        });
    }

    /*
    * Handle business days toggle
    */
    $scope.toggleManageDueDays = function(){
        if($scope.newTaskObj.useBusinessDays){
            $scope.newTaskObj.useBusinessDays = 0;
        }else{
            $scope.newTaskObj.useBusinessDays = 1;
        }
    }

    /*
     * Initialize function to populate the modal values
     */
    var init = () => {
        if (cell) {
            if (cell.incomingAction) {
                $scope.taskObj.incomingAction = populateData_helper($scope.workflowActions, cell.incomingAction);
                $scope.disableIncoming = true;
            }
            if (cell.outGoingAction) {
                $scope.taskObj.outGoingAction = populateData_helper($scope.workflowActions, cell.outGoingAction);
            }
            $scope.taskObj.task = (cell.workflowTask.taskId) ? populateData_helper($scope.tasksList, { id: cell.workflowTask.taskId }) : null;
            $scope.taskObj.auto_assign = (cell.workflowTask.autoAssign) ? cell.workflowTask.autoAssign : null;
            $scope.taskObj.sequence = (cell.workflowTask.sequence) ? parseInt(cell.workflowTask.sequence) : null;
            $scope.taskObj.onDemand = (cell.workflowTask.onDemand) ? cell.workflowTask.onDemand : null;
            $scope.taskObj.shared = (cell.workflowTask.shared) ? cell.workflowTask.shared : null;
            $scope.taskObj.unifyShared = (cell.workflowTask.unifyShared) ? cell.workflowTask.unifyShared : null;
            $scope.taskObj.asynchronous = (cell.workflowTask.asynchronous) ? cell.workflowTask.asynchronous : null;
        }
    }
    init();
}

/*
 *   Workflow Decision properties
 */
WfDecisionPropertiesController.$inject = ['$scope', 'TapIoRuleSetService', '$ioAlert', '$rootScope', '$timeout'];

function WfDecisionPropertiesController($scope, TapIoRuleSetService, $ioAlert, $rs, $timeout) {
    $scope.formType = 'Decision';
    var workflow = $scope.$parent.$parent.$parent.workflowObj;
    var cell = $scope.$parent.$parent.$parent.cellObj;
    var workflowData = $scope.$parent.$parent.$parent.workflowData;
    $scope.workflowActions = workflow.workflowActions;
    $scope.workflowStatus = workflow.workflowStatus;
    $scope.tapIORuleSets = [];
    $scope.ruleSetObj = { name: "" };
    $scope.selRuleSetObj = { rules: [] };
    $scope.routingConditionObj = {};
    $scope.ruleObj = {};
    $scope.newRuleObj = {};
    $scope.isEdge = false;
    $scope.conditionOutgoing = {
        nodeId: null,
        nodeName: null,
        decision: null
    };
    $scope.conditionOutgoingDecisions = ['True', 'False'];
    $scope.ruleObj.ruleStatusId = null;
    $scope.ruleOperationsList = [];
    $scope.ruleTargetsList = [];

    $scope.selRuleSet = () => {
        if ($scope.routingConditionObj.ruleSetId) {
            $scope.selRuleSetObj = _.find($scope.tapIORuleSets, { id: $scope.routingConditionObj.ruleSetId });
            getTapIORules();
        }
    };

    $scope.goBack = () => {
        $scope.formType = 'Decision';
    };

    $scope.addNewRuleSet = () => {
        $scope.ruleSetObj = { name: "" };
        $scope.formType = 'newRuleSet';
        $scope.newRuleObj = {};
    };

    /**
     * create new Reulw Set and Rule
     */
    $scope.saveRuleSet = (newRuleSetForm) => {
        if (newRuleSetForm.$valid) {
            TapIoRuleSetService.addRuleSet($scope.ruleSetObj).then(function(data) {
                if (data) {
                    $scope.tapIORuleSets.push(data);
                    $scope.newRuleObj.ruleSetId = data.id;
                    $scope.routingConditionObj.ruleSetId = data.id;
                    $scope.selRuleSetObj = _.find($scope.tapIORuleSets, { id: $scope.routingConditionObj.ruleSetId });
                    TapIoRuleSetService.addRule($scope.newRuleObj).then(function(data) {
                        getTapIORules();
                        $ioAlert.show('', 'Rule Added successfully', 'success');
                        $scope.formType = 'Decision';
                    }, function() {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    });
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    };

    /*
     *   create new rule only
     */
    $scope.saveRule = (newRuleForm) => {
        if (newRuleForm.$valid) {
            $scope.newRuleObj.ruleSetId = $scope.selRuleSetObj.id;
            TapIoRuleSetService.addRule($scope.newRuleObj).then(function(data) {
                $ioAlert.show('', 'Rule Added successfully', 'success');
                getTapIORules();
                $scope.goBack();
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });

        }
    };

    /*
     * Helper function to populate the drop downs
     * @param: arr - Array list of the dropdown
     * @param: obj - to be populated object
     */
    function populateData_helper(arr, obj) {
        return _.find(arr, function(item) {
            return item.id == obj.id
        })
    }

    // switch to create new rule modal
    $scope.newRuleModal = () => {
        //$scope.newRule = true;
        $scope.formType = 'newRule';
        $scope.newRuleObj = {};
    };

    /*
    * Handle cancel modal
    */
    $scope.cancel = () => {
        var myElement = angular.element(document.querySelector( '#fieldForm' ));
        myElement.addClass('fieldFormInactive');
        $timeout(function () {
            $scope.$parent.$parent.$parent.show = false;
        }, 1000);
    };

    //add decision to the workflow
    $scope.saveDecision = (decisionForm) => {
        if (decisionForm.$valid) {
            $scope.routingConditionObj.decision = $scope.conditionOutgoing.decision;
            $scope.$parent.$parent.$parent.show = false;
            $rs.$broadcast('WorkflowDecision', $scope.routingConditionObj, cell);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };

    /*
     *   get rule targets
     */
    var getRuleTargets = () => {
        TapIoRuleSetService.getRuleTargets().then(function() {
            $scope.ruleTargetsList = TapIoRuleSetService.ruleTargetsList;
            $scope.ruleTargetSelect2Values = _.map($scope.ruleTargetsList, function(target) {
                return { id: target.field_name, text: target.display_name };
            });
        }, function() {
            console.log('error loading rule targets');
        });
    }

    //add new rule section
    /*$scope.addNewSection = () => {
        $scope.ruleObj.ruleSections.push({
            'ruleSetId': '',
            'ruleObjCondition': $scope.ruleCondition[0].id,
            'ruleOutgoingId': ''
        });
    }

    $scope.removeSection = function() {
        var lastSection = $scope.ruleObj.ruleSections.length - 1;
        $scope.ruleObj.ruleSections.splice(lastSection);
    }*/

    /*
     *  get rulesets list
     */
    var getTapIORuleSets = () => {
        TapIoRuleSetService.getRuleSets().then(function(success) {
            $scope.tapIORuleSets = TapIoRuleSetService.ruleSets;
            $scope.selRuleSet();
        }, function(error) {
            console.log("error loading ruleSets list");
        });
    };

    /*
     *  get rules list
     */
    var getTapIORules = () => {
        $scope.tapIORules = [];
        TapIoRuleSetService.getRulesList($scope.selRuleSetObj.id).then(function() {
            $scope.selRuleSetObj.rules = TapIoRuleSetService.rulesList;
            _.each($scope.selRuleSetObj.rules, function(ruleObj) {
                var ruleOperation = _.find($scope.ruleOperationsList, { id: ruleObj.rule_operation_id });
                if (ruleOperation) {
                    ruleObj.rule_operation_value = ruleOperation.operation_value;
                }
            });
        }, function() {
            console.log("error loading rule list");
        });
    };

    /*
     *   get rule operations list
     */
    var getRuleOperations = () => {
        TapIoRuleSetService.getRuleOperations().then(function() {
            $scope.ruleOperationsList = TapIoRuleSetService.ruleOperationList;
        }, function() {
            console.log("error loading ruleSets list");
        });
    };

    $scope.onRuleTargetChange = function(element, event) {
        $scope.newRuleObj.ruleTarget = event.val;
    };

    $scope.ruleTargetSelect2Options = function() { return {}; };

    $scope.ruleTargetSelect2SelectedValues = _.find($scope.ruleTargetSelect2Values, function(option) {
        return rule && option.id === rule.rule_target
    }) || {};

    $scope.conditionOutgoingChange = function() {
        if ($scope.conditionOutgoing.decision == "True") {
            $scope.routingConditionObj.trueRoutingRuleId = $scope.conditionOutgoing.nodeId;
            $scope.routingConditionObj.trueRoutingRuleName = $scope.conditionOutgoing.nodeName;
            //$scope.routingConditionObj.falseRoutingRuleId = null;
        } else if ($scope.conditionOutgoing.decision == "False") {
            $scope.routingConditionObj.falseRoutingRuleId = $scope.conditionOutgoing.nodeId;
            $scope.routingConditionObj.falseRoutingRuleName = $scope.conditionOutgoing.nodeName;
            //$scope.routingConditionObj.trueRoutingRuleId = null;
        }
    }

    var setRoutingConditionObj = (cell) => {
        if (cell.routingCondition) {
            $scope.routingConditionObj.routingRuleSetId = cell.routingCondition.routingRuleSetId;
            $scope.routingConditionObj.ruleSetId = cell.routingCondition.ruleSetId;
            $scope.routingConditionObj.trueRoutingRuleId = cell.routingCondition.trueRoutingRuleId;
            $scope.routingConditionObj.falseRoutingRuleId = cell.routingCondition.falseRoutingRuleId;
            if ($scope.routingConditionObj.trueRoutingRuleId && $scope.routingConditionObj.falseRoutingRuleId) {
                $scope.conditionOutgoingDecisions = [];
            } else if ($scope.routingConditionObj.trueRoutingRuleId) {
                $scope.conditionOutgoingDecisions = ['False'];
            } else if ($scope.routingConditionObj.falseRoutingRuleId) {
                $scope.conditionOutgoingDecisions = ['True'];
            }
            $scope.routingConditionObj.trueRoutingRuleName = findRoutingRuleName($scope.routingConditionObj.trueRoutingRuleId);
            $scope.routingConditionObj.falseRoutingRuleName = findRoutingRuleName($scope.routingConditionObj.falseRoutingRuleId);
        }
    }

    var findRoutingRuleName = (routingRuleId) => {
        if (routingRuleId) {
            var workflowTask = null;
            if (routingRuleId.substring(0, 1) == "T") {
                workflowTask = _.find(workflowData.workflowTasks, { routingRuleId: routingRuleId });
            } else {
                workflowTask = _.find(workflowData.workflowTasks, { routingRuleId: parseInt(routingRuleId) });
            }
            if (workflowTask && workflowTask.taskId && workflow.tasksList) {
                var taskObj = _.find(workflow.tasksList, { id: workflowTask.taskId });
                if (taskObj) return taskObj.name;
            }
            return "Task";
        }
        return "";
    }

    var init = () => {
        getTapIORuleSets();
        getRuleOperations();
        getRuleTargets();
        if (cell && cell.edge === true) { // if clicked on edge
            $scope.isEdge = true;
            //$scope.ruleObj.ruleStatusId = cell.source.parent.statusId;
            setRoutingConditionObj(cell.source);
            if (cell.source.incomingAction) {
                $scope.ruleObj.incomingAction = populateData_helper($scope.workflowActions, cell.source.incomingAction);
                $scope.disableIncoming = true;
            }
            $scope.conditionOutgoing.nodeId = (cell.target.routingRule.id) ? cell.target.routingRule.id : cell.target.routingRule._id;
            $scope.conditionOutgoing.nodeName = (cell.target.value) ? cell.target.value : "Task";
        } else if (cell) { // if clicked on decision box
            //$scope.ruleObj.ruleStatusId = cell.parent.statusId;
            setRoutingConditionObj(cell);
            if (cell.incomingAction) {
                $scope.ruleObj.incomingAction = populateData_helper($scope.workflowActions, cell.incomingAction);
                $scope.disableIncoming = true;
            }
        }
    }
    init();
}

/*
    Workflow Status Changer
*/
WfStatusChangerController.$inject = ['$scope', '$ioAlert', '$rootScope', '$timeout'];

function WfStatusChangerController($scope, $ioAlert, $rs, $timeout) {
    $scope.statusChangerText = "Status Changer Properties";
    $scope.statusChangeObj = {};

    var workflow = $scope.$parent.$parent.$parent.workflowObj;
    var cell = $scope.$parent.$parent.$parent.cellObj;

    $scope.workflowActions = workflow.workflowActions;
    $scope.workflowStatus = workflow.workflowStatus;
    $scope.statusChangeObj.newStatusId = cell.parent.statusId;

    /*
     * Helper function to populate the drop downs
     * @param: arr - Array list of the dropdown
     * @param: obj - to be populated object
     */
    function populateData_helper(arr, obj) {
        return _.find(arr, function(item) {
            return item.id == obj.id
        })
    }

    //add rule to the workflow
    $scope.changeStatus = (statusForm) => {
        if (statusForm.$valid) {
            $scope.$parent.$parent.$parent.show = false;
            $rs.$broadcast('WorkflowStatusChanger', $scope.statusChangeObj, cell);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };

    /*
    * Handle cancel modal
    */
    $scope.cancel = () => {
        var myElement = angular.element(document.querySelector( '#fieldForm' ));
        myElement.addClass('fieldFormInactive');
        $timeout(function () {
            $scope.$parent.$parent.$parent.show = false;
        }, 1000);
    };

    var init = () => {
        if (cell) {
            if (cell.incomingAction) {
                $scope.statusChangeObj.incomingAction = populateData_helper($scope.workflowActions, cell.incomingAction);
                $scope.disableIncoming = true;
            }
            if (cell.newStatusId) {
                $scope.statusChangeObj.newStatusId = cell.newStatusId;
            }
            if (cell.incomingStatus) {
                $scope.statusChangeObj.statusId = cell.incomingStatus;
            }
        }
    }
    init();
}

InitialStatusController.$inject = ['$scope', '$ioAlert', '$rootScope', '$timeout'];

function InitialStatusController($scope, $ioAlert, $rs, $timeout) {
    $scope.statusObj = {};

    var workflowObj = $scope.$parent.$parent.$parent.workflowObj;
    var cell = $scope.$parent.$parent.$parent.cellObj;
    $scope.workflowActions = workflowObj.workflowActions;

    /*
     * Helper function to populate the drop downs
     * @param: arr - Array list of the dropdown
     * @param: obj - to be populated object
     */
    function populateData_helper(arr, obj) {
        return _.find(arr, function(item) {
            return item.id == obj.id
        })
    };

    $scope.updateAction = (statusForm) => {
        if (statusForm.$valid) {
            $scope.$parent.$parent.$parent.show = false;
            $rs.$broadcast('InitialWorkflowStatus', cell, $scope.statusObj);
        } else {
            $ioAlert.show('Error!', 'Please fill the all required fields', 'error');
        }
    };


    /*
    * Handle cancel modal
    */
    $scope.cancel = () => {
        var myElement = angular.element(document.querySelector( '#fieldForm' ));
        myElement.addClass('fieldFormInactive');
        $timeout(function () {
            $scope.$parent.$parent.$parent.show = false;
        }, 1000);
    };

    function init() {
        $scope.statusObj.action = populateData_helper($scope.workflowActions, cell.outGoingAction);
    };

    init();

};

WorkflowGraphCtrl.$inject = ['$scope', 'workflowObj', '$q', '$modalInstance', 'WorkflowsService', '$ioAlert'];

function WorkflowGraphCtrl($scope, workflowObj, $q, $modalInstance, WorkflowsService, $ioAlert) {
    $scope.workflowObj = workflowObj;
    $scope.scheduledRouting = false;

    /*
     * Helper function to validate the graph
     */
    function validateGraph_helper() {
        return true;
    }

    /*
     * Save the graphical workflow to the database
     */
    $scope.workflowSave = function(workflowData) {
        //return false;
        //Save data to the database only if the validations are passed
        if (validateGraph_helper(workflowData)) {
            $scope.loadInProgress = true;
            if (workflowData.routingRuleSets) {
                var tmpRoutingRuleSets = angular.copy(workflowData.routingRuleSets);

                var routingRuleSetSave = function() {
                    if (tmpRoutingRuleSets.length > 0) {
                        var routingRuleSetObj = tmpRoutingRuleSets[0];
                        tmpRoutingRuleSets.shift();
                        if (routingRuleSetObj.id) {
                            WorkflowsService.updateRoutingRuleSet(routingRuleSetObj, $scope.scheduledRouting).then(function(response) {
                                routingRuleSetSave();
                            }, function(error) {
                                $scope.loadInProgress = false;
                                console.log("error updating routing rule set");
                                routingRuleSetSave();
                            });
                        } else {
                            routingRuleSetObj.workflowId = (routingRuleSetObj.workflowId === null) ? workflowData.id : routingRuleSetObj.workflowId;
                            WorkflowsService.addRoutingRuleSet(routingRuleSetObj, $scope.scheduledRouting).then(function(response) {
                                if (response && response.id && response._id) {
                                    var routingRuleSetData = _.find(workflowData.routingRuleSets, { _id: response._id });
                                    if (routingRuleSetData) {
                                        routingRuleSetData.id = response.id;
                                    }
                                }
                                routingRuleSetSave();
                            }, function(error) {
                                $scope.loadInProgress = false;
                                console.log("error adding routing rule set");
                                routingRuleSetSave();
                            });
                        }
                    } else {
                        $scope.loadInProgress = false;
                        routingRuleSave(workflowData);
                    }
                }
                routingRuleSetSave();
            }
        } else {
            //Push the relative error messages to the UI
        }
    }

    /*
     * Helper function to save the routing Rule
     */
    function routingRuleSave(workflowData) {
        if (workflowData.routingRules) {
            $scope.loadInProgress = true;
            _.each(workflowData.routingRules, function(routingRuleObj) {
                if (routingRuleObj.routingRuleSetId && String(routingRuleObj.routingRuleSetId).substring(0, 1) == 'T') {
                    var routingRuleSetObj = _.find(workflowData.routingRuleSets, { _id: routingRuleObj.routingRuleSetId });
                    if (routingRuleSetObj) {
                        routingRuleObj.routingRuleSetId = routingRuleSetObj.id;
                    }
                }
            });
            var requestPromise = [];
            _.each(workflowData.routingRules, function(routingRuleObj) {
                if (routingRuleObj.id) {
                    requestPromise.push(WorkflowsService.updateRoutingRules(routingRuleObj, $scope.scheduledRouting).then(function(response) {
                        return response;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        $scope.loadInProgress = false;
                    }));
                } else {
                    requestPromise.push(WorkflowsService.addRoutingRules(routingRuleObj, $scope.scheduledRouting).then(function(response) {
                        if (response && response.id && response._id) {
                            var routingRuleData = _.find(workflowData.routingRules, { _id: response._id });
                            if (routingRuleData) {
                                routingRuleData.id = response.id;
                            }
                        } else if (response && response.id) {
                            routingRuleObj.id = response.id;
                        }
                        return response;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        $scope.loadInProgress = false;
                    }));
                }
            });
            $q.all(requestPromise).then(function(data) {
                $scope.loadInProgress = false;
                routingConditionSave(workflowData);
            });
        }
    }

    /*
     * Helper function to save routing conditions
     */
    function routingConditionSave(workflowData) {
        if (workflowData.routingConditions) {
            $scope.loadInProgress = true;
            _.each(workflowData.routingConditions, function(routingConditionObj) {
                if (routingConditionObj.routingRuleSetId && String(routingConditionObj.routingRuleSetId).substring(0, 1) == 'T') {
                    var routingRuleSetObj = _.find(workflowData.routingRuleSets, { _id: routingConditionObj.routingRuleSetId });
                    if (routingRuleSetObj) {
                        routingConditionObj.routingRuleSetId = routingRuleSetObj.id;
                    }
                }
                if (routingConditionObj.trueRoutingRuleId && String(routingConditionObj.trueRoutingRuleId).substring(0, 1) == 'T') {
                    var routingRuleObj = _.find(workflowData.routingRules, { _id: routingConditionObj.trueRoutingRuleId });
                    if (routingRuleObj) {
                        routingConditionObj.trueRoutingRuleId = routingRuleObj.id;
                    }
                }
                if (routingConditionObj.falseRoutingRuleId && String(routingConditionObj.falseRoutingRuleId).substring(0, 1) == 'T') {
                    var routingRuleObj = _.find(workflowData.routingRules, { _id: routingConditionObj.falseRoutingRuleId });
                    if (routingRuleObj) {
                        routingConditionObj.falseRoutingRuleId = routingRuleObj.id;
                    }
                }
            });
            var requestPromise = [];
            _.each(workflowData.routingConditions, function(routingConditionObj) {
                if (routingConditionObj.id) {
                    requestPromise.push(WorkflowsService.updateRoutingCondition(routingConditionObj).then(function(response) {
                        return response;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        $scope.loadInProgress = false;
                    }));
                } else {
                    requestPromise.push(WorkflowsService.addRoutingCondition(routingConditionObj).then(function(response) {
                        if (response && response.id && response._id) {
                            var routingConditionData = _.find(workflowData.routingConditions, { _id: response._id });
                            if (routingConditionData) {
                                routingConditionData.id = response.id;
                            }
                        } else if (response && response.id) {
                            routingConditionObj.id = response.id;
                        }
                        return response;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        $scope.loadInProgress = false;
                    }));
                }

            });
            $q.all(requestPromise).then(function(data) {
                $scope.loadInProgress = false;
                workflowTaskSave(workflowData);
            });
        } else {
            $scope.loadInProgress = false;
            workflowTaskSave(workflowData);
        }
    }

    /*
     * Helper function to save workflow tasks
     */
    function workflowTaskSave(workflowData) {
        if (workflowData.workflowTasks) {
            $scope.loadInProgress = true;
            _.each(workflowData.workflowTasks, function(workflowTaskObj) {
                if (workflowTaskObj.routingRuleId && String(workflowTaskObj.routingRuleId).substring(0, 1) == 'T') {
                    var routingRuleObj = _.find(workflowData.routingRules, { _id: workflowTaskObj.routingRuleId });
                    if (routingRuleObj) {
                        workflowTaskObj.routingRuleId = routingRuleObj.id;
                    }
                }
            });
            var requestPromise = [];
            _.each(workflowData.workflowTasks, function(workflowTaskObj) {
                if (workflowTaskObj.id) {
                    requestPromise.push(WorkflowsService.updateWorkflowTask(workflowTaskObj).then(function(response) {
                        return response;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        $scope.loadInProgress = false;
                    }));
                } else {
                    requestPromise.push(WorkflowsService.addWorkflowTask(workflowTaskObj).then(function(response) {
                        if (response && response.id && response._id) {
                            var workflowTaskData = _.find(workflowData.workflowTasks, { _id: response._id });
                            if (workflowTaskData) {
                                workflowTaskData.id = response.id;
                            }
                        } else if (response && response.id) {
                            workflowTaskObj.id = response.id;
                        }
                        return response;
                    }, function(error) {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                        $scope.loadInProgress = false;
                    }));
                }
            });
            $q.all(requestPromise).then(function(data) {
                $ioAlert.show('', "Workflow saved successfully", 'success');
                $scope.loadInProgress = false;
                workflowInfoSave(workflowData);

            });
        } else {
            workflowInfoSave(workflowData);
        }
    }

    function workflowInfoSave(workflowData) {
        //$scope.loadInProgress = true;
        workflowData.ioGraph = CircularJSON.stringify(workflowData.graphModel().cells);
        var workflowParam = {
            id: workflowData.id,
            hasIoGraph: "1",
            ioGraph: (workflowData.ioGraph) ? workflowData.ioGraph : "",
            initialStatusId: workflowData.initialStatusId,
            name: workflowData.name,
            typeId: workflowData.typeId,
            referenceId: workflowData.referenceId
        }
        WorkflowsService.updateWorkflow(workflowParam).then(function(response) {
            $scope.loadInProgress = false;
            $modalInstance.close();
        }, function(error) {
            console.log("error updating workflow");
            $scope.loadInProgress = false;
            $modalInstance.close();
        });
    };

    /*
     * Delete Routing Rule Set
     */
    function deleteRuleSet(cellObj) {
        if (cellObj.routingRuleSetId) {
            WorkflowsService.deleteRoutingRuleSet(cellObj.routingRuleSetId).then(function(data) {
                if (data.errors) {
                    $ioAlert.show('Error!', 'RuleSet was not deleted. Please delete Rules first!', 'error');
                } else {
                    $ioAlert.show('', 'RuleSet deleted successfully', 'success');
                    workflowInfoSave(cellObj.workflowData);
                }
            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            })
        }
    };

    /*
     * delete Routing rule
     */
    function deleteRoutingRule(cellObj) {
        if (cellObj.routingRuleId) {
            WorkflowsService.deleteRoutingRule(cellObj.routingRuleId).then(function(data) {
                $ioAlert.show('', 'Rule deleted successfully', 'success');
                if (cellObj.routingRuleSetId) {
                    deleteRuleSet(cellObj)
                } else {
                    workflowInfoSave(cellObj.workflowData);
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
    };


    $scope.deleteCell = function(cellObj) {
        switch (cellObj.type) {
            case 'routingRule':
                deleteRoutingRule(cellObj);
                break;
            case 'routingRuleSet':
                break;
            case 'task':
                break;
        }
    }

    // Dismiss the graph workflow modal
    $scope.closeWorkflow = () => {
        $modalInstance.dismiss();
    };
}